// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:38.543Z
// Property: West 530 (ID: 6767906449166552)
// Collections: 25 amenities, 2 floorplans (live), 60 photos, 53 POIs, 5 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166552",
  "property_external_id": "2430993",
  "property_zillow_url": "https://www.zillow.com/homedetails/530-West-Pryor-OK-74361/2077327319_zpid/",
  "property_apartments_url": "https://www.apartments.com/west-530-pryor-ok/0p8m3t2/",
  "property_google_business_url": "https://www.google.com/maps/place/West+530/data=!4m2!3m1!1s0x0:0x3228422bb4c8536e?sa=X&ved=2ahUKEwi7ipvzhL2SAxX4MlkFHT2ZNuQQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40833884270",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "west-530-i",
  "property_name": "West 530",
  "property_website_url": "https://www.caseusa.com/apartments/ok/pryor/west-530/",
  "property_domain": null,
  "property_address": "3660 W 530 Rd",
  "property_full_address": "3660 W 530 Rd, Pryor, OK, 74361",
  "property_address_1": "3660 W 530 Rd",
  "property_address_2": null,
  "property_address_city": "Pryor",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74361",
  "property_address_country": "US",
  "property_address_county": "Mayes County",
  "property_neighborhood_address": "https://www.caseusa.com/apartments/ok/pryor/west-530/",
  "property_address_latitude": "36.2504",
  "property_address_longitude": "-95.3218",
  "property_email": "West530@caseusa.com",
  "property_phone": "(539) 212-2597",
  "property_call_tracking_phone": "844-755-4278",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At West 530 in Pryor, OK, find your perfect blend of style and comfort with one- and two-bedroom floor plans. Enjoy luxury amenities like a serene pond, vibrant dog park, and state-of-the-art fitness center. Experience a lifestyle that elevates everyday living—schedule a tour or check availability to start your journey today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to West 530, where modern living meets unparalleled convenience in the heart of Pryor, OK. Our thoughtfully designed apartment community offers a variety of spacious floor plans, including one-bedroom and two-bedroom options, tailored to fit your lifestyle. \n\nExperience exceptional amenities that elevate your living experience, from our refreshing pool and state-of-the-art fitness center to inviting clubhouses perfect for social gatherings. With full-time doormen and on-site management available 24/7, you'll enjoy peace of mind and support whenever you need it. \n\nStay active with our basketball and pickleball courts or unwind on scenic walking and biking trails. Our community is pet-friendly, featuring a dedicated dog park that your furry friends will love. Enjoy the outdoors with our grill area, or relax by the serene pond surrounded by nature.\n\nEach apartment boasts modern features like granite countertops, stainless steel appliances, and spacious walk-in closets. Stay comfortable year-round with air conditioning and ceiling fans, while high-speed internet ensures you’re always connected. Enjoy the convenience of in-unit washers and dryers, providing you with everything you need for hassle-free living. \n\nAt West 530, we prioritize your comfort, offering smoke-free living spaces equipped with all the modern essentials like microwaves, dishwashers, and balconies or patios for your relaxation. \n\nDon’t wait! Find your new home today—browse our availability or schedule a tour to visit our vibrant community. Experience the lifestyle you deserve at West 530!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
  "property_featured_image_media": {
    "alt_text": "Comfortable lounge area with leather sofas, a fireplace, and a ping pong table.",
    "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
    "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "128",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.21875",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "410",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets per unit. Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed (breed restrictions apply). Pet rent is $30 per pet per month. $500 non‑refundable fee per pet. $30 pet screening. Service animals are not considered pets; pet fees and pet rent do not apply to service animals.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://west530.securecafe.com/onlineleasing/west-530-i-and-ii/floorplans.aspx",
  "property_resident_portal_url": "https://west530.securecafenet.com/residentservices/west-530-i-and-ii/userlogin",
  "property_apply_now_url": "https://west530.securecafe.com/onlineleasing/west-530-i-and-ii/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-92c5-707e-8a39-e2ae8e966e86.webp",
  "property_primary_logo_media": {
    "alt_text": "West 530 Luxury Apartments logo",
    "public_id": "019cfb50-92c5-707e-8a39-e2ae8e966e86",
    "storage_key": "property/6767906449166552/019cfb50-92c5-707e-8a39-e2ae8e966e86.webp",
    "width": 640,
    "height": 213
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-8a04-7149-8946-5c3d279cf699.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb50-8a04-7149-8946-5c3d279cf699",
    "storage_key": "property/6767906449166552/019cfb50-8a04-7149-8946-5c3d279cf699.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-92c5-707e-8a39-e2ae8e966e86.webp",
  "property_mono_white_logo_media": {
    "alt_text": "West 530 Luxury Apartments logo",
    "public_id": "019cfb50-92c5-707e-8a39-e2ae8e966e86",
    "storage_key": "property/6767906449166552/019cfb50-92c5-707e-8a39-e2ae8e966e86.webp",
    "width": 640,
    "height": 213
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-a703-7633-b436-5bfddca5eacd.webp",
  "property_mono_black_logo_media": {
    "alt_text": "West 530 Luxury Apartments logo.",
    "public_id": "019cfb50-a703-7633-b436-5bfddca5eacd",
    "storage_key": "property/6767906449166552/019cfb50-a703-7633-b436-5bfddca5eacd.webp",
    "width": 640,
    "height": 213
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#e11b22",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1050",
  "property_sqft_min": "789",
  "property_sqft_max": "1050",
  "property_price_range": "1199 - 1479",
  "property_price_min": "1199",
  "property_price_max": "1479",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/West530AptsPryor/reels/",
  "property_instagram_url": "https://www.instagram.com/west530living/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe5oMmds5tocRblPItCtCKDI",
  "property_youtube_url": "https://www.youtube.com/watch?v=1mg_cG6KSjU",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Cheap+Apartments+for+Rent&find_loc=Pryor+Creek%2C+OK",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to West 530",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Welcome to West 530 in Pryor, OK, where modern living meets convenience. Our spacious one- and two-bedroom apartments boast granite countertops, stainless steel appliances, and walk-in closets. Enjoy exclusive amenities like a refreshing pool, fitness center, and dog park, all designed for your comfort and lifestyle. Embrace your new home!",
  "property_home_floorplans_blurb": "At West 530 in Pryor, OK, your ideal lifestyle awaits among our thoughtfully designed one and two-bedroom apartments. Each floor plan harmonizes comfort and modern elegance, creating the perfect sanctuary. Browse our available options and uncover the space that suits your unique needs and style. Your new home is just a click away!",
  "property_home_gallery_blurb": "At West 530 in Pryor, OK, experience a lifestyle tailored to comfort and convenience. From spacious one and two-bedroom floor plans to exceptional amenities like a shimmering pool, fitness center, and dog park, every detail enhances your living experience. Imagine unwinding on your private balcony—your new home awaits!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Pryor, OK, West 530 offers a vibrant lifestyle just steps away from the natural beauty of Whitaker Park and the serene Pryor Creek Nature Trail. With diverse floor plans and a community surrounded by local gems like the Pryor Public Library and Rogers State University, your ideal home awaits.",
  "property_home_reviews_blurb": "Welcome to West 530 in Pryor, OK, where the charm of our community shines through glowing resident experiences! With a peaceful atmosphere, fast maintenance, and friendly staff, it’s no wonder one resident praises, “The maintenance team is amazing! They respond so quickly to my requests.” Join us and feel the warmth of home!",
  "property_neighborhood_blurb": "At West 530 in Pryor, OK, enjoy a vibrant community packed with unique treasures. Stroll through the lush Pryor Creek Nature Trail, engage with local culture at the Coo-Y-Yah Museum, or explore the parks nearby. Embrace a lifestyle where comfort meets adventure—just steps from your new home. Discover your neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At West 530 in Pryor, OK, every detail is designed for your comfort and lifestyle. Enjoy resort-style amenities like our sparkling pool, state-of-the-art fitness center, and dog park! Spacious one and two-bedroom apartments boast modern finishes including granite countertops and stainless steel appliances. Elevate your living experience today!",
  "property_applynow_blurb": "Welcome to West 530 in Pryor, OK, where modern living meets comfort. Choose from spacious one or two-bedroom floor plans, complete with sleek granite countertops and stainless steel appliances. Enjoy a vibrant community featuring a refreshing pool, fitness center, dog park, and serene walking trails. Lease online today to find your ideal home!",
  "property_contactus_blurb": "At West 530 in Pryor, OK, an array of thoughtfully designed one and two-bedroom floor plans await you. Each layout is crafted to enhance your lifestyle, offering both comfort and style. Curious about finding your perfect home? Our leasing team is ready to assist—reach out today!",
  "property_faqs_blurb": "At West 530 in Pryor, OK, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Curious about amenities, pet policies, or lease terms? Uncover the answers you seek on our FAQs page and find out what makes our apartment community a perfect place to call home.",
  "property_floorplans_blurb": "At West 530 in Pryor, OK, stylish living awaits with thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Each apartment offers a unique blend of comfort and modern convenience, making it easy to call this vibrant community home. Browse our available options and uncover your ideal space today!",
  "property_gallery_blurb": "At West 530 in Pryor, OK, life is a blend of comfort and adventure. Choose from our spacious one- and two-bedroom floor plans, bask in the sun by the pool, or get active on the basketball and pickleball courts. Picture yourself here, where modern living meets serene landscapes.",
  "property_interactivemap_blurb": "At West 530 in Pryor, OK, choose from stylish one and two-bedroom apartments featuring granite countertops and stainless steel appliances. Enjoy unparalleled amenities, including a refreshing pool, fitness center, and dog park. Ready to find your next sanctuary? Use our interactive community map to explore available apartments today!",
  "property_pets_blurb": "At West 530 in Pryor, OK, your four-legged friends are cherished with no weight limits—bring two pets to make your home complete! With modern amenities and a friendly community, comfort and convenience await. Enjoy nature trails nearby, perfect for daily strolls with your furry companions.",
  "property_referafriend_blurb": "At West 530 in Pryor, OK, your ideal living space awaits. Choose from our stylish one- and two-bedroom floor plans tailored for comfort and connection. Refer a friend and expand your community—great friends make great neighbors! Join us today and transform your living experience into something truly special.",
  "property_residentaccess_blurb": "Welcome to West 530 in Pryor, OK, where comfort meets convenience! With thoughtfully designed one and two-bedroom floor plans, your perfect home awaits. Access your resident portal now to pay rent, schedule maintenance, and enjoy a seamless living experience tailored just for you!",
  "property_reviews_blurb": "At West 530 in Pryor, OK, residents rave about the welcoming atmosphere and top-notch maintenance. One resident exclaimed, \"The management is friendly and outstanding in communication,\" highlighting the genuine community connection. With beautiful apartments, swift maintenance, and a safe environment, you’ll quickly feel right at home. See what our residents have to say!",
  "property_created_at": "1759851616349",
  "property_scheduletour_blurb": "At West 530 in Pryor, OK, your perfect living space awaits. Choose from spacious one and two-bedroom floor plans designed for comfort and style. Curious about life here? Schedule a tour today and hear firsthand experiences from our happy residents who truly make this community home!",
  "property_thankyou_blurb": "Thank you for reaching out to West 530 in Pryor, OK! We offer thoughtfully designed one and two-bedroom apartments, blending modern comfort with local charm. Our team will connect with you soon to discuss how you can call West 530 home. Your ideal living space awaits!",
  "property_virtualtours_blurb": "At West 530 in Pryor, OK, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Experience modern living set against a vibrant community backdrop. Take a virtual tour today and envision your future home with us!",
  "property_copyright": "2025 All Rights Reserved. West 530",
  "property_seo_title_home": "West 530 |  Apartments in Pryor, OK",
  "property_seo_description_home": "Experience upscale living at West 530 in Pryor, OK. Enjoy resort-style amenities, stylish apartments, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Pryor, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at West 530 in Pryor, OK! Choose from stylish one and two-bedroom floor plans tailored to fit your lifestyle.",
  "property_seo_title_amenities": "Amenities | Pryor, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience luxurious living at West 530 in Pryor, OK! Enjoy resort-style amenities, stunning floor plans, and a vibrant community—your ideal home awaits.",
  "property_seo_title_gallery": "Gallery | Apartments in Pryor, OK",
  "property_seo_description_gallery": "Experience modern living at West 530 in Pryor, OK. With stunning amenities, spacious floor plans, and inviting spaces, picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | West 530 Apartments",
  "property_seo_description_virtualtours": "Step into West 530 in Pryor, OK! Enjoy one and two-bedroom apartments—take a virtual tour today and imagine your life in this vibrant community!",
  "property_seo_title_interactivemap": "Interactive Map | West 530 Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at West 530 in Pryor, OK! Use our interactive map to explore stunning floor plans, amenities, and pricing options tailored for you.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Pryor, OK",
  "property_seo_description_neighborhood": "Uncover the charm of Pryor, OK at West 530! Find your perfect one or two-bedroom home and enjoy vibrant local spots just moments away. Join us today!",
  "property_seo_title_contact": "Contact Us | West 530",
  "property_seo_description_contact": "Find your ideal home at West 530 in Pryor, OK. Choose from spacious one and two-bedroom floor plans. Got questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Pryor, OK",
  "property_seo_description_faqs": "Uncover your ideal lifestyle at West 530 in Pryor, OK! Get answers to your burning questions and learn about our stunning amenities and floor plans.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Pryor, OK",
  "property_seo_description_reviews": "Experience life at West 530 in Pryor, OK! Dive into resident reviews and see why our community's amenities and lifestyle resonate with so many happy neighbors!",
  "property_seo_title_applynow": "Apply Now | Apartments in Pryor, OK",
  "property_seo_description_applynow": "Find your perfect home at West 530 in Pryor, OK! Enjoy luxurious amenities, modern floor plans, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | West 530",
  "property_seo_description_residentaccess": "Experience seamless living at West 530 in Pryor, OK. Log in to your resident portal for rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | West 530",
  "property_seo_description_referafriend": "Refer a friend to West 530 in Pryor, OK! Share the joy of great neighbors and enjoy exclusive perks together. Your ideal home awaits!",
  "property_seo_title_scheduletour": "Schedule a Tour | West 530",
  "property_seo_description_scheduletour": "Tour West 530 in Pryor, OK, where comfort meets style. Experience modern living and vibrant community life—schedule your visit today!",
  "property_seo_title_privacy": "Privacy Policy | West 530",
  "property_seo_description_privacy": "Safeguard your peace of mind at West 530 in Pryor, OK. Our privacy policy ensures your information is protected. Click to learn more about our commitment!",
  "property_seo_title_accessibility": "Website Accessibility | West 530",
  "property_seo_description_accessibility": "At West 530 in Pryor, OK, we prioritize digital inclusion. Explore our commitment to accessibility and embrace a community where everyone belongs.",
  "property_seo_title_sitemap": "Sitemap | West 530",
  "property_seo_description_sitemap": "Uncover the layout of West 530 in Pryor, OK. Navigate our community features, amenities, and more with ease. Check out our sitemap for a complete overview!",
  "property_seo_title_thankyou": "Thank You | West 530",
  "property_seo_description_thankyou": "Thank you for reaching out to West 530 in Pryor, OK! Our team is excited to assist you in finding your perfect apartment home. Stay tuned for our call!",
  "property_seo_title_pets": "Pet Policy | Apartments in Pryor, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866175727",
  "amenities": [
    {
      "id": "ec_cac88da2faa804574f96986c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127902407",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58cd559e2c32273c36c56ee5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404799",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_335399dc817f2503998fb7f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404801",
      "title": "24 Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d758f3486b8e96f8ec8548e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404802",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d3c0fec6579b59fc683c39d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404803",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40da1663ed48b25a8a6f8b95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404804",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed3a1bc61d551da6f9567423",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404805",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29be36406da1b8f64a759565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "128050629",
      "title": "Basket Ball Court/ Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc42182d8dce8669bdcaddc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "128017325",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b2097589f9675d8ba1022fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "128050666",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f585fc987bf83750e1fdd25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127902404",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44640d640a5703ce32220bad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127902402",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bc7cae7f410670c2b9551d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127902401",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dee355580bdff8fc19213c3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127902400",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b87f9ca0aea03fa35d6272ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404806",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e117aaa81240c16111c76bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404807",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7ecb1cdc7dae7d5a2e21ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404810",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7ab61ac82b7d2802e18d3bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404811",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_915a5974ba25fabe0af075b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404813",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d33980e9dfe9b086c4fa3c29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404814",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04c8e35fc9d4bc63df7565fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404815",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f08517d0069ae24a7e6ba6d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404816",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_309ed52ca2e339b92ad6726f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404817",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bc3483baea0110f18ad88b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404818",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2df2ab0009e6a63583fc3f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "yardi",
      "external_id": "127404819",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_919ebce7-6dd1-44e8-a181-660a85309bbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-5679-762a-9920-cbfb627ccfc6.webp",
      "image_media": {
        "alt_text": "A bright bedroom with a bed, nightstand, round mirror, and an open closet with shelving.",
        "public_id": "019f0561-5679-762a-9920-cbfb627ccfc6",
        "storage_key": "property/6767906449166552/019f0561-5679-762a-9920-cbfb627ccfc6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfortable living in our spacious apartment bedrooms. This well-appointed room features a cozy bed, stylish nightstand, and ample closet space with convenient shelving for your wardrobe.",
      "link": "",
      "alt_text": "A bright bedroom with a bed, nightstand, round mirror, and an open closet with shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63ea3ab5-9cd4-4863-b94e-cd786cf07619",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-35b1-7599-852a-067ac772c371.webp",
      "image_media": {
        "alt_text": "Living room with sofa, accent chairs, dining table and chairs.",
        "public_id": "019f0561-35b1-7599-852a-067ac772c371",
        "storage_key": "property/6767906449166552/019f0561-35b1-7599-852a-067ac772c371.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and spacious living area with comfortable seating and a dining nook, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, accent chairs, dining table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1208ce9-4c1c-4602-ae77-f08684c6b4c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-30b0-75ca-a498-f98fbe919f9a.webp",
      "image_media": {
        "alt_text": "Open pantry with wire shelving and light wood floors next to a modern refrigerator and wall decor.",
        "public_id": "019f0561-30b0-75ca-a498-f98fbe919f9a",
        "storage_key": "property/6767906449166552/019f0561-30b0-75ca-a498-f98fbe919f9a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Discover generous storage options with a well-organized pantry, designed to keep your apartment clutter-free and functional. Featuring wire shelving and light wood floors.",
      "link": "",
      "alt_text": "Open pantry with wire shelving and light wood floors next to a modern refrigerator and wall decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed055130-16fd-4dfa-9530-a3d0c4f3bd49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-1965-77fa-9a80-5f8e81e3da37.webp",
      "image_media": {
        "alt_text": "Close-up of a kitchen sink with a stainless steel pull-down faucet and granite countertops, with a living room and windows in the background.",
        "public_id": "019f0561-1965-77fa-9a80-5f8e81e3da37",
        "storage_key": "property/6767906449166552/019f0561-1965-77fa-9a80-5f8e81e3da37.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy modern amenities in your new apartment home. This kitchen features sleek granite countertops and a contemporary stainless steel faucet, perfect for everyday living and entertaining.",
      "link": "",
      "alt_text": "Close-up of a kitchen sink with a stainless steel pull-down faucet and granite countertops, with a living room and windows in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_555dbe13-0a31-4795-9779-e805c08f64ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-3082-7129-afb9-902545bbca8f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets and granite countertops.",
        "public_id": "019f0561-3082-7129-afb9-902545bbca8f",
        "storage_key": "property/6767906449166552/019f0561-3082-7129-afb9-902545bbca8f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinets, sleek granite countertops, and stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6e4cbc7a-2761-4499-8627-6700a7b9d05b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-009e-719d-a867-ea58248d257a.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table set for four, featuring grey chairs and decorative vases.",
        "public_id": "019f0561-009e-719d-a867-ea58248d257a",
        "storage_key": "property/6767906449166552/019f0561-009e-719d-a867-ea58248d257a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in your spacious apartment, complete with a stylish table setting and comfortable seating.",
      "link": "",
      "alt_text": "Dining area with a round wooden table set for four, featuring grey chairs and decorative vases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50de0e65-5207-4f02-a4fa-2d0a250c19f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-4942-732f-bce3-fe85b6fbfa04.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, nightstand with a lamp, and a dresser.",
        "public_id": "019f0561-4942-732f-bce3-fe85b6fbfa04",
        "storage_key": "property/6767906449166552/019f0561-4942-732f-bce3-fe85b6fbfa04.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our spacious bedrooms, featuring elegant furniture and ample natural light.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, nightstand with a lamp, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_686b8c3d-359f-405b-9914-71ab7b997ae5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-26f1-75ce-822d-17903bbf30e6.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and dishwasher, open to living room with TV.",
        "public_id": "019f0561-26f1-75ce-822d-17903bbf30e6",
        "storage_key": "property/6767906449166552/019f0561-26f1-75ce-822d-17903bbf30e6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring a granite countertop island with a stainless steel sink and dishwasher, flowing into a living area with a TV and natural light.",
      "link": "",
      "alt_text": "Kitchen island with sink and dishwasher, open to living room with TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_38b9b0a2-54b2-4975-8a90-eca58a4379f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-47f2-726d-af67-e8fcb33d9f6f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and mounted TV.",
        "public_id": "019f0561-47f2-726d-af67-e8fcb33d9f6f",
        "storage_key": "property/6767906449166552/019f0561-47f2-726d-af67-e8fcb33d9f6f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a plush queen-size bed, a modern ceiling fan, and an entertainment center with a flat-screen TV.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b822df6-e56b-4420-95a1-8a9672f680c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-ff4f-768c-b4cb-a6a7e7bb7474.webp",
      "image_media": {
        "alt_text": "Modern living room with a TV, coffee table, and armchair.",
        "public_id": "019f0560-ff4f-768c-b4cb-a6a7e7bb7474",
        "storage_key": "property/6767906449166552/019f0560-ff4f-768c-b4cb-a6a7e7bb7474.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a large television, comfortable seating, and contemporary decor.",
      "link": "",
      "alt_text": "Modern living room with a TV, coffee table, and armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aad15f1f-f875-4687-a09e-ce66129b421d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-d16c-746e-b69d-16a7c686dc6b.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with granite countertops, stainless steel appliances, dark cabinets, and a breakfast bar with two woven stools.",
        "public_id": "019f0560-d16c-746e-b69d-16a7c686dc6b",
        "storage_key": "property/6767906449166552/019f0560-d16c-746e-b69d-16a7c686dc6b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover your culinary haven in this modern apartment kitchen, featuring sleek granite countertops, stainless steel appliances, and ample dark cabinetry. Enjoy casual dining at the breakfast bar, complete with stylish woven stools.",
      "link": "",
      "alt_text": "Modern apartment kitchen with granite countertops, stainless steel appliances, dark cabinets, and a breakfast bar with two woven stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8641ce01-5406-445c-ac10-9a5d1d8e0a61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-af61-70dc-9e92-e3c9ff86c958.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "019f0560-af61-70dc-9e92-e3c9ff86c958",
        "storage_key": "property/6767906449166552/019f0560-af61-70dc-9e92-e3c9ff86c958.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and clean apartment bathroom featuring a granite-top vanity, a comfortable bathtub with shower, and modern fixtures. Perfect for relaxation and daily routines.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_76619862-c7b0-449b-a246-9b325f56867a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-fbdb-763f-8185-9323d86c67be.webp",
      "image_media": {
        "alt_text": "Dining area and living room with a white couch and TV.",
        "public_id": "019f0560-fbdb-763f-8185-9323d86c67be",
        "storage_key": "property/6767906449166552/019f0560-fbdb-763f-8185-9323d86c67be.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This open-concept living space features a dining area with a round table and chairs, and a living room with a comfortable sofa and entertainment center.",
      "link": "",
      "alt_text": "Dining area and living room with a white couch and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d783dbc2-b786-4cf1-a3b7-bb20c7280e33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0561-0e24-75ed-8a18-e080e21b109a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019f0561-0e24-75ed-8a18-e080e21b109a",
        "storage_key": "property/6767906449166552/019f0561-0e24-75ed-8a18-e080e21b109a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek dark wood cabinetry, elegant granite countertops, and a full suite of stainless steel appliances. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2fd45165-4ed2-4176-9e5a-a088659de228",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-e9eb-722f-8376-774dcda2afe3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a breakfast bar with two stools.",
        "public_id": "019f0560-e9eb-722f-8376-774dcda2afe3",
        "storage_key": "property/6767906449166552/019f0560-e9eb-722f-8376-774dcda2afe3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, granite countertops, a subway tile backsplash, and stainless steel appliances. Includes a convenient breakfast bar with seating.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a breakfast bar with two stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3259ecd-ecc5-49ce-857b-f92d284c8017",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-afb0-7422-8dc8-7946835010f3.webp",
      "image_media": {
        "alt_text": "Modern living room with kitchen island and bar stools",
        "public_id": "019f0560-afb0-7422-8dc8-7946835010f3",
        "storage_key": "property/6767906449166552/019f0560-afb0-7422-8dc8-7946835010f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a large sofa, coffee table, and a kitchen island with bar stools, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with kitchen island and bar stools",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2df1a27a-1c11-4889-9162-f149b0ea0a87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-ef69-778e-b93d-8083db4ea95d.webp",
      "image_media": {
        "alt_text": "Bright and airy dining area with a round table, chairs, and decorative vases, adjacent to a living room with a sofa.",
        "public_id": "019f0560-ef69-778e-b93d-8083db4ea95d",
        "storage_key": "property/6767906449166552/019f0560-ef69-778e-b93d-8083db4ea95d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a stylish dining area and a cozy living room perfect for relaxation.",
      "link": "",
      "alt_text": "Bright and airy dining area with a round table, chairs, and decorative vases, adjacent to a living room with a sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0ffd6f4-0363-442f-aa1f-0eca4c7f930b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-af40-75bf-bd6c-0cfec1465794.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, TV, and ceiling fan.",
        "public_id": "019f0560-af40-75bf-bd6c-0cfec1465794",
        "storage_key": "property/6767906449166552/019f0560-af40-75bf-bd6c-0cfec1465794.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable white sofa, entertainment center with a large TV, and a stylish ceiling fan. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with a white sofa, TV, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e09f37a4-a38c-486a-b47b-55ab2367d2e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-b104-77e6-bb8d-561f60f194c5.webp",
      "image_media": {
        "alt_text": "Laundry area with washer, dryer, and trash bin.",
        "public_id": "019f0560-b104-77e6-bb8d-561f60f194c5",
        "storage_key": "property/6767906449166552/019f0560-b104-77e6-bb8d-561f60f194c5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry area with a stacked washer and dryer, a trash receptacle, and a vanity with granite countertops and a sink.",
      "link": "",
      "alt_text": "Laundry area with washer, dryer, and trash bin.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_699cc03d-ab56-42bc-9a6c-360752b09889",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-ae9f-73e4-a174-512d7e0a0400.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertop, sink, faucet, and decorative orchid.",
        "public_id": "019f0560-ae9f-73e4-a174-512d7e0a0400",
        "storage_key": "property/6767906449166552/019f0560-ae9f-73e4-a174-512d7e0a0400.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a spacious double vanity with a granite countertop, a modern sink, and elegant fixtures. This bathroom also features a convenient in-unit washer and dryer.",
      "link": "",
      "alt_text": "Double vanity bathroom with granite countertop, sink, faucet, and decorative orchid.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_200fca29-e4c6-4671-8ff4-0810bb75c080",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-af61-70dc-9e92-e6188685df6f.webp",
      "image_media": {
        "alt_text": "Cozy bedroom featuring a queen-size bed with white linens, decorative pillows, a nightstand with a lamp, and a walk-in closet.",
        "public_id": "019f0560-af61-70dc-9e92-e6188685df6f",
        "storage_key": "property/6767906449166552/019f0560-af61-70dc-9e92-e6188685df6f.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Relax in comfort in our beautifully appointed bedrooms, complete with plush bedding and ample closet space for all your storage needs.",
      "link": "",
      "alt_text": "Cozy bedroom featuring a queen-size bed with white linens, decorative pillows, a nightstand with a lamp, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b69dc9c-e7c2-4f03-80be-944f354d7991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-b043-7658-9f71-9b5f7b9b508b.webp",
      "image_media": {
        "alt_text": "Modern living room with white sofa, accent chair, coffee table, and ceiling fan.",
        "public_id": "019f0560-b043-7658-9f71-9b5f7b9b508b",
        "storage_key": "property/6767906449166552/019f0560-b043-7658-9f71-9b5f7b9b508b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring comfortable seating, a stylish coffee table, and large windows.",
      "link": "",
      "alt_text": "Modern living room with white sofa, accent chair, coffee table, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_16e26348-9c01-44a0-9f4f-1b6afcce2277",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f0560-ae82-761d-b318-7d3cafbfe6a1.webp",
      "image_media": {
        "alt_text": "Modern living room with a light gray sofa, decorative pillows, and a round coffee table.",
        "public_id": "019f0560-ae82-761d-b318-7d3cafbfe6a1",
        "storage_key": "property/6767906449166552/019f0560-ae82-761d-b318-7d3cafbfe6a1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, accent pillows, and a round coffee table, perfect for relaxation.",
      "link": "",
      "alt_text": "Modern living room with a light gray sofa, decorative pillows, and a round coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_85f76694-952f-4a23-935f-e5120ace86ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-5346-7497-880e-887217f38407.webp",
      "image_media": {
        "alt_text": "Outdoor sports court with a net and residential apartment buildings under a blue sky with white clouds.",
        "public_id": "019f055e-5346-7497-880e-887217f38407",
        "storage_key": "property/6767906449166552/019f055e-5346-7497-880e-887217f38407.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Serve up some fun on our community's multi-sport court, perfect for a lively game of volleyball or pickleball. Enjoy active living and connect with neighbors in a vibrant outdoor setting.",
      "link": "",
      "alt_text": "Outdoor sports court with a net and residential apartment buildings under a blue sky with white clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a57ac43-375b-40aa-9031-b0b6ab032df8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-69db-71ea-a6ad-7b4ff347db6f.webp",
      "image_media": {
        "alt_text": "A large outdoor swimming pool with lounge chairs and umbrellas, an apartment building, and a clubhouse under a blue sky.",
        "public_id": "019f055e-69db-71ea-a6ad-7b4ff347db6f",
        "storage_key": "property/6767906449166552/019f055e-69db-71ea-a6ad-7b4ff347db6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, surrounded by comfortable lounge seating and shaded umbrellas, with views of our modern apartment homes and inviting clubhouse.",
      "link": "",
      "alt_text": "A large outdoor swimming pool with lounge chairs and umbrellas, an apartment building, and a clubhouse under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6de3aa8-2427-46b7-a5f7-8350870400aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-5122-7259-8a5c-ccfa8545ebf3.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with apartment buildings in the background under a clear blue sky",
        "public_id": "019f055e-5122-7259-8a5c-ccfa8545ebf3",
        "storage_key": "property/6767906449166552/019f055e-5122-7259-8a5c-ccfa8545ebf3.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Enjoy active living on our community's outdoor basketball court, set against the backdrop of modern apartment buildings, perfect for a sunny day game.",
      "link": "",
      "alt_text": "Outdoor basketball court with apartment buildings in the background under a clear blue sky",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e2b22698-51ed-4590-90ab-b7b306fdf089",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-844c-7490-8c46-8e1a14658b62.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station and seating area with fire pit and lounge chairs.",
        "public_id": "019f055e-844c-7490-8c46-8e1a14658b62",
        "storage_key": "property/6767906449166552/019f055e-844c-7490-8c46-8e1a14658b62.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and relaxation in our community grilling area, complete with comfortable seating and a cozy fire pit.",
      "link": "",
      "alt_text": "Outdoor grilling station and seating area with fire pit and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3ea326d-d5ed-4c77-89ec-06bf342cce72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-6617-769c-984d-087bc8b73b76.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana at a modern apartment complex.",
        "public_id": "019f055e-6617-769c-984d-087bc8b73b76",
        "storage_key": "property/6767906449166552/019f055e-6617-769c-984d-087bc8b73b76.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing on a sunny day. The adjacent cabana offers shaded seating and grilling areas for outdoor enjoyment.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana at a modern apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9700ec0f-f40e-4890-9ac0-3729e2a98a32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-8fb1-7322-a916-87741b769321.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with grills, seating, and a TV.",
        "public_id": "019f055e-8fb1-7322-a916-87741b769321",
        "storage_key": "property/6767906449166552/019f055e-8fb1-7322-a916-87741b769321.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy socializing and grilling in our outdoor lounge, featuring comfortable seating, a large television, and convenient grills.",
      "link": "",
      "alt_text": "Outdoor lounge area with grills, seating, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_deba8f7d-29a6-446e-ac47-d3fbff8b46ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-787c-778b-9d76-c57ae0669ad1.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with sofas and tables in front of apartment building.",
        "public_id": "019f055e-787c-778b-9d76-c57ae0669ad1",
        "storage_key": "property/6767906449166552/019f055e-787c-778b-9d76-c57ae0669ad1.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor lounge area, featuring comfortable seating and tables perfect for socializing or enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor seating area with sofas and tables in front of apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b3075bce-e37e-4665-aed7-5fc43b0763d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-5a7a-750b-abfa-f9590aef90fb.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana.",
        "public_id": "019f055e-5a7a-750b-abfa-f9590aef90fb",
        "storage_key": "property/6767906449166552/019f055e-5a7a-750b-abfa-f9590aef90fb.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, perfect for relaxing and unwinding. Adjacent cabana offers shaded seating and dining areas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_612a8681-8006-4954-88b2-e3e8a70db2a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-6a98-773c-863a-4cf2bdf8c1a3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019f055e-6a98-773c-863a-4cf2bdf8c1a3",
        "storage_key": "property/6767906449166552/019f055e-6a98-773c-863a-4cf2bdf8c1a3.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by comfortable lounge seating and lush landscaping. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94528dbd-c123-4c67-926d-9508d64a4077",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-4733-75fc-bdc5-091fd1922ee2.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court and apartment buildings with balconies.",
        "public_id": "019f055e-4733-75fc-bdc5-091fd1922ee2",
        "storage_key": "property/6767906449166552/019f055e-4733-75fc-bdc5-091fd1922ee2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy active living at our community with a dedicated outdoor basketball court, perfect for a friendly game or some exercise. The modern apartment buildings offer comfortable living spaces.",
      "link": "",
      "alt_text": "Outdoor basketball court and apartment buildings with balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1ab87a3-3812-4b67-9d3a-7761a7ab0578",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055d-dca5-75bd-89e4-c6d027f417b1.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with a large 'NOW LEASING!' banner featuring a pool image.",
        "public_id": "019f055d-dca5-75bd-89e4-c6d027f417b1",
        "storage_key": "property/6767906449166552/019f055d-dca5-75bd-89e4-c6d027f417b1.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover West 530 Luxury Apartments! This modern building exterior showcases our vibrant community. Explore available units and inquire today!",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with a large 'NOW LEASING!' banner featuring a pool image.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_801e54c5-3095-4bbf-91b5-384953621765",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055d-c7a4-749a-a0a5-edf898b78afa.webp",
      "image_media": {
        "alt_text": "A modern business center with a brown sofa, a wooden desk with a computer and printer, and two office chairs. Large windows look out to the property exterior.",
        "public_id": "019f055d-c7a4-749a-a0a5-edf898b78afa",
        "storage_key": "property/6767906449166552/019f055d-c7a4-749a-a0a5-edf898b78afa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our community's modern business center offers a comfortable and productive space for residents, featuring stylish furnishings, a computer, printer, and ample natural light.",
      "link": "",
      "alt_text": "A modern business center with a brown sofa, a wooden desk with a computer and printer, and two office chairs. Large windows look out to the property exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b7be802-3a83-4dca-92b0-a48dee96a1a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-2fa5-74f4-8bf7-44409448527f.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies, green lawn, and a basketball court.",
        "public_id": "019f055e-2fa5-74f4-8bf7-44409448527f",
        "storage_key": "property/6767906449166552/019f055e-2fa5-74f4-8bf7-44409448527f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of a modern apartment building, showcasing its design with balconies and surrounding green spaces, including a basketball court.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies, green lawn, and a basketball court.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99c89083-16df-430f-8929-9869b222ac44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055e-22b9-74a0-a90b-709108615ddf.webp",
      "image_media": {
        "alt_text": "Mini golf putting green and walking path with apartment buildings in the background.",
        "public_id": "019f055e-22b9-74a0-a90b-709108615ddf",
        "storage_key": "property/6767906449166552/019f055e-22b9-74a0-a90b-709108615ddf.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a friendly game of mini golf on our putting green, perfect for resident recreation.",
      "link": "",
      "alt_text": "Mini golf putting green and walking path with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd0bf2d4-ad75-428e-bfb6-2efbcfcd9ac1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055d-dd64-775a-94bd-2af01a16e59e.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with a red cube sculpture in the foreground.",
        "public_id": "019f055d-dd64-775a-94bd-2af01a16e59e",
        "storage_key": "property/6767906449166552/019f055d-dd64-775a-94bd-2af01a16e59e.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "View of apartment buildings from the entrance, featuring a large red cube sculpture with the property's name and website.",
      "link": "",
      "alt_text": "Modern apartment buildings with a red cube sculpture in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb8390e4-17cd-4d2f-b8ba-2ba80b570046",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055d-c747-75ca-a778-435018de7243.webp",
      "image_media": {
        "alt_text": "West 530 Luxury Apartments monument sign with address 3660 West 530 Road.",
        "public_id": "019f055d-c747-75ca-a778-435018de7243",
        "storage_key": "property/6767906449166552/019f055d-c747-75ca-a778-435018de7243.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Monument sign for West 530 Luxury Apartments, located at 3660 West 530 Road. The sign features the property name and address against a backdrop of a blue sky with clouds.",
      "link": "",
      "alt_text": "West 530 Luxury Apartments monument sign with address 3660 West 530 Road.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0cc919f-3a58-455c-96ca-5ebde2d3503f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055d-df8b-7378-9e2f-0cb8261ef68b.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including a jump bar and weave poles.",
        "public_id": "019f055d-df8b-7378-9e2f-0cb8261ef68b",
        "storage_key": "property/6767906449166552/019f055d-df8b-7378-9e2f-0cb8261ef68b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Let your furry friends play and exercise in our dedicated dog park, complete with fun agility equipment.",
      "link": "",
      "alt_text": "Dog park with agility equipment including a jump bar and weave poles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d3c35c3-90bb-4b13-a27c-005c62468859",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019f055d-c86a-725c-856b-64eb73d1f3b2.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and a modern apartment building in the background.",
        "public_id": "019f055d-c86a-725c-856b-64eb73d1f3b2",
        "storage_key": "property/6767906449166552/019f055d-c86a-725c-856b-64eb73d1f3b2.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our stunning resort-style pool, perfect for relaxing and soaking up the sun. Adjacent to the clubhouse, it's the ideal spot for leisure.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and a modern apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73c123a7-d89f-44a7-8542-c0f4b9f25925",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-696b-72cc-94f1-52f896471c51.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a dark metal bed frame, dresser, and two large windows.",
        "public_id": "01a03546-696b-72cc-94f1-52f896471c51",
        "storage_key": "property/6767906449166552/01a03546-696b-72cc-94f1-52f896471c51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting bedroom, perfect for relaxation after a long day.",
      "link": "",
      "alt_text": "A cozy bedroom featuring a dark metal bed frame, dresser, and two large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4aa3a8a7-3f36-4abc-a914-af3b713b5b55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-6713-769b-92de-5adf48f90c5a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, toilet, and bathtub with shower curtain.",
        "public_id": "01a03546-6713-769b-92de-5adf48f90c5a",
        "storage_key": "property/6767906449166552/01a03546-6713-769b-92de-5adf48f90c5a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious vanity, a modern toilet, and a clean, inviting bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32b52dde-45e7-4af4-8b5a-074d8bd3a692",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-60de-71df-b4b5-78b0af6ebef9.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, and vanity",
        "public_id": "01a03546-60de-71df-b4b5-78b0af6ebef9",
        "storage_key": "property/6767906449166552/01a03546-60de-71df-b4b5-78b0af6ebef9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious laundry room with modern vanity, full-size washer and dryer, and decorative artwork.",
      "link": "",
      "alt_text": "Laundry room with washer, dryer, and vanity",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3775c957-9b53-4179-9329-46dade7894fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-4af6-73ca-8cc8-66ac1385eee2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an open living area.",
        "public_id": "01a03546-4af6-73ca-8cc8-66ac1385eee2",
        "storage_key": "property/6767906449166552/01a03546-4af6-73ca-8cc8-66ac1385eee2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the open-concept living in this beautifully designed apartment. Featuring a sleek kitchen with modern appliances and ample counter space, seamlessly flowing into a comfortable living area.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an open living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93bfe9bd-e434-4df0-962d-3792d4f71fe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-3ec6-726b-9648-8d648b9991c3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "01a03546-3ec6-726b-9648-8d648b9991c3",
        "storage_key": "property/6767906449166552/01a03546-3ec6-726b-9648-8d648b9991c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this bright and spacious kitchen, featuring sleek white cabinetry, a full suite of stainless steel appliances, and a stylish subway tile backsplash. Perfect for preparing meals and entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c78783ef-1b88-49ca-81e6-f77b4256cead",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-395c-70ec-b37d-8d4656163131.webp",
      "image_media": {
        "alt_text": "Dining area with round table and chairs, adjacent to a balcony door.",
        "public_id": "01a03546-395c-70ec-b37d-8d4656163131",
        "storage_key": "property/6767906449166552/01a03546-395c-70ec-b37d-8d4656163131.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, featuring a round table and comfortable seating, with access to a private balcony.",
      "link": "",
      "alt_text": "Dining area with round table and chairs, adjacent to a balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b0768a0-f117-4b19-9b3f-194287488c41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-375f-70f2-9be7-d003fa451933.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "01a03546-375f-70f2-9be7-d003fa451933",
        "storage_key": "property/6767906449166552/01a03546-375f-70f2-9be7-d003fa451933.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring pristine white cabinetry, sleek stainless steel appliances including a French door refrigerator, and a large countertop island perfect for meal prep and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9ea6287d-bb4e-4306-938c-8ba7a1a32863",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-1638-708d-bbd4-8e13b953cf6f.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed and checkered bedding, next to a window and a nightstand.",
        "public_id": "01a03546-1638-708d-bbd4-8e13b953cf6f",
        "storage_key": "property/6767906449166552/01a03546-1638-708d-bbd4-8e13b953cf6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, stylish bedding, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed and checkered bedding, next to a window and a nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e35a853-8089-4c4f-8dc6-389f9ff0c522",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-188b-7367-9748-1895172761ba.webp",
      "image_media": {
        "alt_text": "Modern living room with a fireplace, large windows, and comfortable seating.",
        "public_id": "01a03546-188b-7367-9748-1895172761ba",
        "storage_key": "property/6767906449166552/01a03546-188b-7367-9748-1895172761ba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a cozy fireplace and ample natural light.",
      "link": "",
      "alt_text": "Modern living room with a fireplace, large windows, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c88c2e30-ad02-48da-a1a5-2d999bbbbf62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-1758-7003-b029-d4a67b437c52.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table overlooking community amenities and apartment buildings.",
        "public_id": "01a03546-1758-7003-b029-d4a67b437c52",
        "storage_key": "property/6767906449166552/01a03546-1758-7003-b029-d4a67b437c52.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze from the private balcony, offering picturesque views of the community grounds and neighboring apartment buildings.",
      "link": "",
      "alt_text": "Balcony with two chairs and a table overlooking community amenities and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14855e40-ee6c-43c2-9da3-547db7af286b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-02f9-77c8-ac7f-4f4aaa3d9e99.webp",
      "image_media": {
        "alt_text": "Modern living room and dining area with large windows and natural light",
        "public_id": "01a03546-02f9-77c8-ac7f-4f4aaa3d9e99",
        "storage_key": "property/6767906449166552/01a03546-02f9-77c8-ac7f-4f4aaa3d9e99.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and bright living and dining areas, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room and dining area with large windows and natural light",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c3a0d1d-804b-4ae3-af91-2a53421a7d3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-ffe9-746c-806d-23338562dbcb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and sink.",
        "public_id": "01a03545-ffe9-746c-806d-23338562dbcb",
        "storage_key": "property/6767906449166552/01a03545-ffe9-746c-806d-23338562dbcb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This beautifully appointed bathroom features a spacious bathtub, a modern vanity with a granite countertop, and a clean, white toilet.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7344476e-786d-470d-bac4-f872ebd07a49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-c73d-7402-a3cc-d5c15daa4bb5.webp",
      "image_media": {
        "alt_text": "Spacious living room with large windows, a sectional sofa, and decorative armchair.",
        "public_id": "01a03545-c73d-7402-a3cc-d5c15daa4bb5",
        "storage_key": "property/6767906449166552/01a03545-c73d-7402-a3cc-d5c15daa4bb5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, featuring a plush sectional, comfortable seating, and ample natural light.",
      "link": "",
      "alt_text": "Spacious living room with large windows, a sectional sofa, and decorative armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2ce5343-fa36-47d2-a0ed-7e1779d4c7d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-c627-75f6-b580-08a30a6a01df.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, dark wood cabinets, stainless steel appliances, and an island with a sink.",
        "public_id": "01a03545-c627-75f6-b580-08a30a6a01df",
        "storage_key": "property/6767906449166552/01a03545-c627-75f6-b580-08a30a6a01df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and function in this stunning apartment kitchen, featuring sleek granite countertops and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, dark wood cabinets, stainless steel appliances, and an island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a61f7024-f795-406a-b730-e3f79279b03c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b238-721c-a0fa-b54230998530.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and subway tile backsplash.",
        "public_id": "01a03545-b238-721c-a0fa-b54230998530",
        "storage_key": "property/6767906449166552/01a03545-b238-721c-a0fa-b54230998530.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek dark wood cabinetry, elegant granite countertops, and modern stainless steel appliances. The subway tile backsplash adds a touch of sophistication.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa8df0c7-056a-4c0f-97d4-166d38311079",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b15a-754d-95b8-99644e0736a2.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstands, dresser, and window.",
        "public_id": "01a03545-b15a-754d-95b8-99644e0736a2",
        "storage_key": "property/6767906449166552/01a03545-b15a-754d-95b8-99644e0736a2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant nightstands, and a spacious dresser.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstands, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11373f23-6b61-46e1-ba85-00a35e2bd146",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b163-711c-b532-dcc5133bc07c.webp",
      "image_media": {
        "alt_text": "Walk-in closet with wire shelving and two pillows.",
        "public_id": "01a03545-b163-711c-b532-dcc5133bc07c",
        "storage_key": "property/6767906449166552/01a03545-b163-711c-b532-dcc5133bc07c.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving for organized storage. Perfect for keeping your belongings tidy.",
      "link": "",
      "alt_text": "Walk-in closet with wire shelving and two pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a29e8c09-1be3-4a3f-ad39-54023e3de92d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b15b-7488-a420-3dfd7d41edda.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a toilet, vanity, and shower.",
        "public_id": "01a03545-b15b-7488-a420-3dfd7d41edda",
        "storage_key": "property/6767906449166552/01a03545-b15b-7488-a420-3dfd7d41edda.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and stylish bathroom featuring a toilet, granite countertop vanity with white cabinets, and a shower with a taupe curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a toilet, vanity, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29f38b48-fdc2-42fb-8338-d678f40ed8aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b165-73d8-b4ee-cd34c0667749.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "01a03545-b165-73d8-b4ee-cd34c0667749",
        "storage_key": "property/6767906449166552/01a03545-b165-73d8-b4ee-cd34c0667749.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "A spacious and well-equipped kitchen featuring stainless steel appliances, ample cabinet storage, and a breakfast bar with granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a3760979-1908-4578-8854-3b6b29681ff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Dutch Pantry",
      "poi_type": "Restaurants",
      "poi_address": "10 W Main St, Chouteau, OK 74337, USA",
      "poi_short_description": "Low-key, seat-yourself, buffet joint with homestyle, all-you-can-eat American staples & baked goods.",
      "poi_long_description": "People say this Pennsylvania Dutch restaurant offers a buffet with homemade rolls, numerous vegetable sides, fresh salad bar, and daily meat options, as well as a wide selection of pies, cobblers, puddings, and cakes. They highlight the food is hearty, satisfying, and reminiscent of home cooking, and the desserts are delicious. They also like the relaxed, family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1bb4-77f6-8cbb-986854c62efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1bb4-77f6-8cbb-986854c62efe",
        "storage_key": "property/6767906449166552/019cfb50-1bb4-77f6-8cbb-986854c62efe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Dutch-Pantry-230003663699534/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4245396448153504687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dutch-pantry",
      "poi_latitude": "36.1868781",
      "poi_longitude": "-95.3438781",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-476-6441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XWrM1Y-tocRrwvllpOt6jo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0332538b-142b-4a7a-b12f-7868d4bbde8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "JL's Barbeque",
      "poi_type": "Restaurants",
      "poi_address": "5501 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "Casual, cafeteria-style BBQ joint with a menu of chicken, brisket, ribs and beans.",
      "poi_long_description": "People say this barbecue restaurant serves delicious pork, brisket, and ribs, with generous portions of sides like potato salad and potato planks. They also highlight the fair prices, friendly staff, and the availability of different sauces.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f349-73fb-97be-f996d07dead6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f349-73fb-97be-f996d07dead6",
        "storage_key": "property/6767906449166552/019cfb4f-f349-73fb-97be-f996d07dead6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://jlsbarbecue.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17598932805801606317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jls-barbeque",
      "poi_latitude": "36.255744",
      "poi_longitude": "-95.333762",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-825-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4sokO05tocRrfzFyyT4O_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_36c5a8d6-d5d6-4db3-8d75-b684cdcc9a77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Hooker's Bar And Grill",
      "poi_type": "Restaurants",
      "poi_address": "4427 W 530, Pryor, OK 74361, USA",
      "poi_short_description": "Bar and grill offering fried pickles, garbage fries, and other comfort eats with beer and cocktails, plus sports on TV.",
      "poi_long_description": "People say this bar and grill serves amazing wings, catfish, and steak sandwiches. They also highlight the friendly service and fun vibe.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1afa-7229-ada3-a6fd03cd4c11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1afa-7229-ada3-a6fd03cd4c11",
        "storage_key": "property/6767906449166552/019cfb50-1afa-7229-ada3-a6fd03cd4c11.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://hookersbarandgrill.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9743201029861551460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hookers-bar-and-grill",
      "poi_latitude": "36.2489413",
      "poi_longitude": "-95.3352949",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-803-0443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-0584-711e-890b-fd1e86d6992c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-0584-711e-890b-fd1e86d6992c",
        "storage_key": "property/6767906449166552/019cfb50-0584-711e-890b-fd1e86d6992c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJufiKlD45tocRZC0eCLfNNoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_487725f1-923c-4d64-9a84-4658187a2d77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "5315 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Some diners say this fast food restaurant serves delicious burgers, fries, and the Monterey Melt.\n\nOther reviews mention the food can be cold and orders can be wrong.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1b22-7379-8f75-030c8c7e4b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1b22-7379-8f75-030c8c7e4b06",
        "storage_key": "property/6767906449166552/019cfb50-1b22-7379-8f75-030c8c7e4b06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.whataburger.com/ok/pryor/5315-s-mill-street.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=7100010868658545837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "36.2605343",
      "poi_longitude": "-95.332882",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-803-0184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyzVIYOk5tocRrSTOf0ROiGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3520236b-00ca-43b4-9e41-8f03f3fdbe13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Big Bellies Burgers",
      "poi_type": "Restaurants",
      "poi_address": "3986 W 530 Suite D, Pryor, OK 74361, USA",
      "poi_short_description": "Casual restaurant serving burgers and Philly cheesesteaks, plus wings, beer, and TV sports.",
      "poi_long_description": "People say this hamburger restaurant serves delicious, juicy burgers with fresh ingredients, as well as onion rings, fries, and cheese curds. They highlight the generous portions, the fun atmosphere with games like pool and cornhole, and the clean and spacious interior. They also like the friendly and welcoming staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f219-7058-b639-a0880d6ae586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f219-7058-b639-a0880d6ae586",
        "storage_key": "property/6767906449166552/019cfb4f-f219-7058-b639-a0880d6ae586.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.online/business/big-bellies-burgers-11643157",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898374717919623052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "big-bellies-burgers",
      "poi_latitude": "36.2498564",
      "poi_longitude": "-95.32761080000002",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-803-0227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIa9f9DE5tocRjHdC-N6owc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_2f5880e2-44fd-4b65-a9e3-72d5e756e475",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "KLA Mart Warehouse",
      "poi_type": "Shopping & Retail",
      "poi_address": "601 N Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "Bargain home goods retailer stocking surplus and close-out household items alongside home-improvement supplies.",
      "poi_long_description": "People say this home goods store offers a wide variety of items, including tools, appliances, and household goods. They also highlight the great prices and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f1e8-76bc-9b78-8932615979f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f1e8-76bc-9b78-8932615979f3",
        "storage_key": "property/6767906449166552/019cfb4f-f1e8-76bc-9b78-8932615979f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://klamart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8192462124728503222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kla-mart-warehouse",
      "poi_latitude": "36.3159759",
      "poi_longitude": "-95.3149241",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-825-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058d-770b-b98e-d9f051b43f3b",
        "storage_key": "property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl-IZff45tocRtstInOV4sXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_59c709a2-dacc-4bb4-a3cd-bcd15fd030ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Fabricut Factory Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "4164 Main Maip St, Pryor, OK 74361, USA",
      "poi_short_description": "Fabric store carrying drapery, upholstery, and wallpaper at discounted prices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1ba5-7707-911a-62a1ba35ee23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1ba5-7707-911a-62a1ba35ee23",
        "storage_key": "property/6767906449166552/019cfb50-1ba5-7707-911a-62a1ba35ee23.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.fabricut.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15053955740998445096&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fabricut-factory-outlet",
      "poi_latitude": "36.242985",
      "poi_longitude": "-95.3360312",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-825-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058d-770b-b98e-d9f051b43f3b",
        "storage_key": "property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXeAGyzI6tocRKCiqtvxk6tA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_d8eb065c-2903-4380-8841-28e76850e2a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Fussell Appliances",
      "poi_type": "Shopping & Retail",
      "poi_address": "1598 OK-69A Unit 1, Pryor, OK 74361, USA",
      "poi_short_description": "Outlet selling an array of used appliances, including stoves and washers, at a discount.",
      "poi_long_description": "People say this appliance store offers a wide selection of used appliances. They also highlight the friendly and polite service, and the ability to choose appliances.\n\nOther reviews mention the appliances can be faulty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f2d8-752c-90fa-df711bfc2ff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f2d8-752c-90fa-df711bfc2ff7",
        "storage_key": "property/6767906449166552/019cfb4f-f2d8-752c-90fa-df711bfc2ff7.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.fussellappliances.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=4141063969617597643",
      "poi_directions_map_url": "https://maps.google.com/?cid=4570641930345505161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fussell-appliances",
      "poi_latitude": "36.2505755",
      "poi_longitude": "-95.2861532",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-210-8143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058d-770b-b98e-d9f051b43f3b",
        "storage_key": "property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwmhQOQ7tocRieG_jZ4ubj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_db16768f-a2d9-4e36-8b4c-81533e093d69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "A Pickers Dream",
      "poi_type": "Shopping & Retail",
      "poi_address": "3888 OK-20, Pryor, OK 74361, USA",
      "poi_short_description": "Antique store featuring a diverse selection of vintage items at fair prices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f300-72ab-8449-16e7f5b4d550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f300-72ab-8449-16e7f5b4d550",
        "storage_key": "property/6767906449166552/019cfb4f-f300-72ab-8449-16e7f5b4d550.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432797178296687375&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "a-pickers-dream",
      "poi_latitude": "36.3069351",
      "poi_longitude": "-95.3837187",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-408-8189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058d-770b-b98e-d9f051b43f3b",
        "storage_key": "property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVx74FYQ5tocRD1t2yXV0qZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_059caabb-cf7a-477d-a38b-6fae6ab6eb30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Harps Food Stores",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 N Chouteau Ave, Chouteau, OK 74337, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f1fe-745a-84fa-b184f101a830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f1fe-745a-84fa-b184f101a830",
        "storage_key": "property/6767906449166552/019cfb4f-f1fe-745a-84fa-b184f101a830.webp",
        "width": 1120,
        "height": 759
      },
      "poi_business_url": "https://www.harpsfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15016388233338474595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harps-food-stores",
      "poi_latitude": "36.1921066",
      "poi_longitude": "-95.3400727",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-476-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058a-703b-8239-bfd5788df647.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058a-703b-8239-bfd5788df647",
        "storage_key": "property/6767906449166552/019cfb50-058a-703b-8239-bfd5788df647.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUfM9j3w_tocRY9B-uYntZNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5ae1ab4e-4347-405c-8ff8-228ae74e79a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Pryor Public Library",
      "poi_type": "Education",
      "poi_address": "505 E Graham Ave, Pryor, OK 74361, USA",
      "poi_short_description": "Public library offering books and computers with free Wi-Fi, plus printing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f7b9-74ca-8cf5-cbebd07e07db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f7b9-74ca-8cf5-cbebd07e07db",
        "storage_key": "property/6767906449166552/019cfb4f-f7b9-74ca-8cf5-cbebd07e07db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pryorlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3204058576476341610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pryor-public-library",
      "poi_latitude": "36.306963",
      "poi_longitude": "-95.3124968",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-825-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnf0rdPc5tocRaoVqqkwadyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d69db34e-d617-454d-ad84-a2b35e20d968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Rogers State University",
      "poi_type": "Education",
      "poi_address": "2155 OK-69A, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f804-77d1-b63a-7592a4dd9681.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f804-77d1-b63a-7592a4dd9681",
        "storage_key": "property/6767906449166552/019cfb4f-f804-77d1-b63a-7592a4dd9681.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.rsu.edu/pryor/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16819716269639307397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rogers-state-university",
      "poi_latitude": "36.2471037",
      "poi_longitude": "-95.2944168",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-825-6117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS_c6DCA6tocRhZC1ItWia-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1556ca36-5a29-41ee-8698-ef62a68839e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Coo-Y-Yah Museum",
      "poi_type": "Entertainment",
      "poi_address": "815 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f8e0-7009-a508-e7ad0ecebb9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f8e0-7009-a508-e7ad0ecebb9c",
        "storage_key": "property/6767906449166552/019cfb4f-f8e0-7009-a508-e7ad0ecebb9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100083230933925",
      "poi_directions_map_url": "https://maps.google.com/?cid=6252406198381410627&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coo-y-yah-museum",
      "poi_latitude": "36.2938482",
      "poi_longitude": "-95.3234995",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-824-5045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057a-71d4-815d-39611115e1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057a-71d4-815d-39611115e1f6",
        "storage_key": "property/6767906449166552/019cfb50-057a-71d4-815d-39611115e1f6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuS3-qZM5tocRQ3n5jU8CxVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_afb6252e-ff00-43ee-9534-9e77fd6db876",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Pryor Tigers Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1351 SE 9th St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1d37-75c8-b930-51fd4c85c723.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1d37-75c8-b930-51fd4c85c723",
        "storage_key": "property/6767906449166552/019cfb50-1d37-75c8-b930-51fd4c85c723.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2531",
      "poi_directions_map_url": "https://maps.google.com/?cid=3080460841976106413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pryor-tigers-football-stadium",
      "poi_latitude": "36.2930607",
      "poi_longitude": "-95.3002983",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-825-2340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057f-77be-8830-109080399046.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057f-77be-8830-109080399046",
        "storage_key": "property/6767906449166552/019cfb50-057f-77be-8830-109080399046.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG9HMo8I5tocRrY18ltD-vyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_256acdad-cd88-4c0a-98b7-cbf842044fa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Pryor Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1135 W Graham Ave, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f7d9-75a9-802f-e61647b44b16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f7d9-75a9-802f-e61647b44b16",
        "storage_key": "property/6767906449166552/019cfb4f-f7d9-75a9-802f-e61647b44b16.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pryorvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14708046406738031435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pryor-veterinary-hospital",
      "poi_latitude": "36.3081096",
      "poi_longitude": "-95.3360782",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-825-1717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-4xY-Y5tocRS7OUxUd6Hcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3a7704f5-e1ca-4721-a91b-00eac04e12b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Renee Hammer DVM",
      "poi_type": "Health and Wellness",
      "poi_address": "2004 W 510, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1d37-75c8-b930-54b119171bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1d37-75c8-b930-54b119171bdd",
        "storage_key": "property/6767906449166552/019cfb50-1d37-75c8-b930-54b119171bdd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://myweb13.site/explore/renee-hammer-dvm",
      "poi_directions_map_url": "https://maps.google.com/?cid=16391146792719078736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renee-hammer-dvm",
      "poi_latitude": "36.2815264",
      "poi_longitude": "-95.2861733",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-825-4087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVZa10s6tocRUNVN-SkNeeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_88a9cc24-1974-4d1d-8ce7-582805513cb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "29 N Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "Fitness center with weights, classes and tanning beds, plus 24/7 access for members.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f913-7624-82e7-405eb45d4057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f913-7624-82e7-405eb45d4057",
        "storage_key": "property/6767906449166552/019cfb4f-f913-7624-82e7-405eb45d4057.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/pryor-oklahoma-4201/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4201",
      "poi_directions_map_url": "https://maps.google.com/?cid=2714511604343357744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "36.3092313",
      "poi_longitude": "-95.3175207",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-824-4799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhV66XPo5tocRMMGPC-zhqyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ae3ac883-62b5-42e5-922f-30426d68753c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Black Sheep Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "12 S Elliott St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-f8f4-73b9-b617-0c85b6a4e96e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f8f4-73b9-b617-0c85b6a4e96e",
        "storage_key": "property/6767906449166552/019cfb4f-f8f4-73b9-b617-0c85b6a4e96e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://black-sheep-salon.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11994702700623180890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "black-sheep-salon",
      "poi_latitude": "36.3053741",
      "poi_longitude": "-95.3100443",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-530-5235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFcUCOcg7tocRWjQQOY6-daY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_0ba00d73-8a5f-47b1-b254-2c5f436f9801",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Quikluxe Nail Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2 S Coo Y Yah St Suite 5, Pryor, OK 74361, USA",
      "poi_short_description": "Clean salon that prides itself on its quality of work and customer satisfaction, offering pedicures, nail art and acrylics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1e58-7396-b29b-b18897e58755.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1e58-7396-b29b-b18897e58755",
        "storage_key": "property/6767906449166552/019cfb50-1e58-7396-b29b-b18897e58755.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://quikluxe-nail-salon.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13895077492284739070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quikluxe-nail-salon",
      "poi_latitude": "36.3064936",
      "poi_longitude": "-95.3135587",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-373-8027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXSaZ2WY5tocR_k0oJlw71cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_982ce42b-a1cb-44fd-a6ef-a3130e615da9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "QuikFit Pryor",
      "poi_type": "Health and Wellness",
      "poi_address": "571 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide selection of new equipment, including dumbbells up to 100 lbs. They highlight the clean and inviting atmosphere, and the friendly and helpful staff. They also like the 24-hour access and the child area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1ecb-712c-9004-065f0b4df2cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1ecb-712c-9004-065f0b4df2cc",
        "storage_key": "property/6767906449166552/019cfb50-1ecb-712c-9004-065f0b4df2cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://quikfitgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13557004601550663014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quikfit-pryor",
      "poi_latitude": "36.296686",
      "poi_longitude": "-95.3214013",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 539-529-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs76zUwE5tocRZm3DZdsnJLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ce6572cd-daac-41bb-95bf-456cdc640805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Vianne Nails and Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "5315 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1f49-7373-8e9a-fd78bea7a4b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1f49-7373-8e9a-fd78bea7a4b2",
        "storage_key": "property/6767906449166552/019cfb50-1f49-7373-8e9a-fd78bea7a4b2.webp",
        "width": 686,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9864117877058609965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vianne-nails-and-spa",
      "poi_latitude": "36.2609705",
      "poi_longitude": "-95.3325659",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-981-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRQ3h-gk5tocRLaOoZPJi5Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_b3cecb5f-dff1-4bd5-b113-304888f27422",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Aspire Salon and Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 Old Airport Rd, Pryor, OK 74361, USA",
      "poi_short_description": "Hair salon offering spray tanning in a comfortable, friendly environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-fc50-710a-9b76-e01e59e4b773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fc50-710a-9b76-e01e59e4b773",
        "storage_key": "property/6767906449166552/019cfb4f-fc50-710a-9b76-e01e59e4b773.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10630095110348767146&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aspire-salon-and-spa",
      "poi_latitude": "36.3367114",
      "poi_longitude": "-95.3066377",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-712-0504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZedvcA86tocRqn_0pC6vhZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_016a8a55-4013-4e0f-b71b-ec02c2e0bb78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Vann Street Hair Company",
      "poi_type": "Health and Wellness",
      "poi_address": "7 N Vann St, Pryor, OK 74361, USA",
      "poi_short_description": "Hair salon offering services such as haircuts and eyebrow waxing at reasonable rates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1fcc-72cc-8fdf-afc38d0fe93d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1fcc-72cc-8fdf-afc38d0fe93d",
        "storage_key": "property/6767906449166552/019cfb50-1fcc-72cc-8fdf-afc38d0fe93d.webp",
        "width": 976,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16139044085540523959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vann-street-hair-company",
      "poi_latitude": "36.30782689999999",
      "poi_longitude": "-95.315361",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-493-0131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9rOu1c5tocRtw8DZRZn-d8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_0f21a51e-d113-4a95-9e6a-d0e3b4316342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Wallaces Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "301 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "Veteran barbershop offering haircuts for generations in a space with a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-1fe7-7136-85a2-537056a2a2df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1fe7-7136-85a2-537056a2a2df",
        "storage_key": "property/6767906449166552/019cfb50-1fe7-7136-85a2-537056a2a2df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18414094742037238614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wallaces-barber-shop",
      "poi_latitude": "36.3019583",
      "poi_longitude": "-95.3200182",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVPUHPI5tocRVpOEF5sBjP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_3f56d2c9-3e5d-4d9c-abc2-d6fcc4de1bc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Hillcrest Pryor",
      "poi_type": "Health and Wellness",
      "poi_address": "111 N Bailey St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-fd5a-711f-95f9-50273274cb37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fd5a-711f-95f9-50273274cb37",
        "storage_key": "property/6767906449166552/019cfb4f-fd5a-711f-95f9-50273274cb37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestpryor111nbaileyst/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=10250480067354606989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-pryor",
      "poi_latitude": "36.3083489",
      "poi_longitude": "-95.3048656",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-825-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-05b5-702d-a839-022046a6dc46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-05b5-702d-a839-022046a6dc46",
        "storage_key": "property/6767906449166552/019cfb50-05b5-702d-a839-022046a6dc46.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWVsgQ6tocRjb3k108FQY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4587f653-6cc1-4aed-9f03-6008880023f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Pryor Creek Golf Course and A&B Golf Shop",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Earl Ward Park, 724 E 530, Pryor, OK 74361, USA",
      "poi_short_description": "Relaxed public golf course with a pro shop, a snack bar and friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-fd4f-734f-93bf-d95d0b7b0bfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fd4f-734f-93bf-d95d0b7b0bfe",
        "storage_key": "property/6767906449166552/019cfb4f-fd4f-734f-93bf-d95d0b7b0bfe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pryorcreekgolf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877452841046772484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pryor-creek-golf-course-and-ab-golf-shop",
      "poi_latitude": "36.2486206",
      "poi_longitude": "-95.2426206",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-825-3056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057f-77be-8830-17ba5258ed01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057f-77be-8830-17ba5258ed01",
        "storage_key": "property/6767906449166552/019cfb50-057f-77be-8830-17ba5258ed01.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22B9iuBGtocRBAsYruuecV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_c942c01c-7a92-4e57-a295-3f55b17cdc87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Whitaker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "401 Park St, Pryor, OK 74361, USA",
      "poi_short_description": "Park with a pond, a walking path, and a splash pad, plus basketball and tennis courts, and a playground.",
      "poi_long_description": "People say this park offers a pond, a skate park, and walking trails. They highlight the park is a great place for kids with play areas, swings, and a splash pad, and that it's a safe, community park suitable for people of all ages. They also like the well-maintained grounds and clean bathrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-fe41-76cb-9b59-87f4f314b0b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe41-76cb-9b59-87f4f314b0b7",
        "storage_key": "property/6767906449166552/019cfb4f-fe41-76cb-9b59-87f4f314b0b7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13291994291968249882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whitaker-park",
      "poi_latitude": "36.3009547",
      "poi_longitude": "-95.3141451",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-087e-75c9-8380-7ca9e142a665",
        "storage_key": "property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-dpa_Q5tocRGpBJcWKmdrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2b18163f-2a5f-439d-9936-9fdc9309131f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Pryor Creek Nature Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4600 S Elliott St, Pryor, OK 74361, USA",
      "poi_short_description": "Kid-friendly hiking area featuring multiple trails and abundant mushrooms and fungi after rainfall.",
      "poi_long_description": "People say this hiking area offers beautiful trails through old wood forests with mature trees and a tranquil creek. They also highlight the well-maintained trails, safe bridges, and gentle inclines, making it suitable for a leisurely walk.\n\nSome reviews mention the trail can be vacant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-fe86-738f-b869-72efdc58ee3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe86-738f-b869-72efdc58ee3c",
        "storage_key": "property/6767906449166552/019cfb4f-fe86-738f-b869-72efdc58ee3c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://pryorcreeknaturetrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11358523634842584127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pryor-creek-nature-trail",
      "poi_latitude": "36.2664476",
      "poi_longitude": "-95.3103179",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN9i32Nc7tocRP8Sr2xCVoZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_16b8fd82-6a8f-485b-b5d9-d5af1e3f6bed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Websters Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1512 Lakeview Cir, Pryor, OK 74361, USA",
      "poi_short_description": "Landscaped garden known for koi ponds and photo ops, along with a trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-21e4-718a-b326-4d8a28d50048.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-21e4-718a-b326-4d8a28d50048",
        "storage_key": "property/6767906449166552/019cfb50-21e4-718a-b326-4d8a28d50048.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15441466808562652683&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "websters-garden",
      "poi_latitude": "36.2865525",
      "poi_longitude": "-95.3223959",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-087e-75c9-8380-7ca9e142a665",
        "storage_key": "property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8FsbpA5tocRC5Zc_z8cS9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_ac2fb1cb-6e60-4558-80ac-112e76b2b256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Guy Williams Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W Harrison Ave, Chouteau, OK 74337, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14854211413468600726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "guy-williams-park",
      "poi_latitude": "36.1922856",
      "poi_longitude": "-95.3435731",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-087e-75c9-8380-7ca9e142a665",
        "storage_key": "property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM8T0j_k-tocRlllZXpTCJM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b901726e-1955-404a-8724-8137e02e256c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Mid-America Industrial Airport-H71",
      "poi_type": "Transportation & Transit",
      "poi_address": "5249 Webb St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-00af-7162-a0b4-13bc6fe1ac68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-00af-7162-a0b4-13bc6fe1ac68",
        "storage_key": "property/6767906449166552/019cfb50-00af-7162-a0b4-13bc6fe1ac68.webp",
        "width": 1280,
        "height": 645
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047135358529384580&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-america-industrial-airport-h71",
      "poi_latitude": "36.2306093",
      "poi_longitude": "-95.3327587",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-476-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-087e-75c9-8380-82af135c94b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-087e-75c9-8380-82af135c94b5",
        "storage_key": "property/6767906449166552/019cfb50-087e-75c9-8380-82af135c94b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJDxw_4rkwtocRhDAxtscFMKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f760e801-ec74-46ae-8826-74aea0d46128",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "MidAmerica Industrial Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4075 Sanders Mitchell St, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-00f1-758c-a81a-1c23db0404bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-00f1-758c-a81a-1c23db0404bc",
        "storage_key": "property/6767906449166552/019cfb50-00f1-758c-a81a-1c23db0404bc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.maip.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2958844549267805071&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midamerica-industrial-park",
      "poi_latitude": "36.2469729",
      "poi_longitude": "-95.2891391",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 888-627-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD70Nbfo5tocRj1O14HDtDyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ea0a553b-ce54-469c-b72d-030b1fdd8716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Housing Authority of The Cherokee Nation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Unnamed Road, Pryor, OK 74361, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-227e-72b5-ae16-d65ee9868a26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-227e-72b5-ae16-d65ee9868a26",
        "storage_key": "property/6767906449166552/019cfb50-227e-72b5-ae16-d65ee9868a26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hacn.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8135762642230190979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "housing-authority-of-the-cherokee-nation",
      "poi_latitude": "36.2290432",
      "poi_longitude": "-95.2497269",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-456-5482 ext. 1167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC7lbjLc9tocRgyMGmwQJ6HA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e8d8db48-0deb-4c0b-b699-a7c2e6618025",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Jefferson Elementary School",
      "poi_type": "Education",
      "poi_address": "400 SE 6th St, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pryorschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16948713862515124072&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jefferson-elementary-school",
      "poi_latitude": "36.2962973",
      "poi_longitude": "-95.3148931",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-825-1374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtW0YSYs5tocRaOfztnXtNes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b7e177b8-9046-450b-aa6a-0e4fa940dd2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Lincoln Elementary School",
      "poi_type": "Education",
      "poi_address": "1625 S Elliott St, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pryorschools.org/o/LESC",
      "poi_directions_map_url": "https://maps.google.com/?cid=12034108139489717231&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lincoln-elementary-school",
      "poi_latitude": "36.2858891",
      "poi_longitude": "-95.308852",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-825-0653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJccO4-yc6tocR7-vr6pe9Aac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_26566b5d-e8e4-485b-93f1-688e29d3fc7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Roosevelt Elementary School",
      "poi_type": "Education",
      "poi_address": "401 N Elliott St, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pryorschools.org/o/res",
      "poi_directions_map_url": "https://maps.google.com/?cid=15750684295596657812&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "roosevelt-elementary-school",
      "poi_latitude": "36.3134608",
      "poi_longitude": "-95.307914",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-825-3523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4zh7zQM6tocRlMxciOqrldo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2ab309ff-1ccf-4ce6-b284-f921aaa0999f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Pryor Middle School",
      "poi_type": "Education",
      "poi_address": "7 S Hogan St, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pryorschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8220005018897648829&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pryor-middle-school",
      "poi_latitude": "36.3053254",
      "poi_longitude": "-95.3115908",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-825-2371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJke4rvPc5tocRvYxSYwNTE3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a06e20db-06a8-49f9-9bf1-9725389dc6f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Pryor High School",
      "poi_type": "Education",
      "poi_address": "1100 SE 9th St, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-c5f7-7629-b38f-a00e37f03b6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c5f7-7629-b38f-a00e37f03b6b",
        "storage_key": "property/6767906449166552/019d7915-c5f7-7629-b38f-a00e37f03b6b.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://www.pryorschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12141242909779872006&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pryor-high-school",
      "poi_latitude": "36.2913252",
      "poi_longitude": "-95.30532",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-825-2340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEVGmWSE6tocRBskocRlcfqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3109b50f-2d7d-4f91-bdb9-f57c100abe31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Northeast Tech - Pryor Campus",
      "poi_type": "Education",
      "poi_address": "6195 W. Highway 20, 6195 OK-20, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-cb44-75d8-a641-1ac30e8ccff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cb44-75d8-a641-1ac30e8ccff4",
        "storage_key": "property/6767906449166552/019d7915-cb44-75d8-a641-1ac30e8ccff4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.netech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13601145110318191977&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northeast-tech-pryor-campus",
      "poi_latitude": "36.308986",
      "poi_longitude": "-95.4251",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-825-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057b-715f-8022-b4eb497b6817",
        "storage_key": "property/6767906449166552/019cfb50-057b-715f-8022-b4eb497b6817.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0hDX9dHtocRaZUOd2r5wLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_f44acb15-dcf9-4afc-8360-3b2121e56e1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Mid-American Grille",
      "poi_type": "Restaurants",
      "poi_address": "101 Cobblestone Dr, Pryor, OK 74361, USA",
      "poi_short_description": "Casual restaurant with a bar serving up burgers, pasta, and a popular chicken fried steak, plus live music.",
      "poi_long_description": "People say this American restaurant serves delicious steaks, fish tacos, and chicken tender salad. They also highlight the friendly and attentive service, and the convenient location.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-c5a1-7273-b4e7-99a64e3b89e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c5a1-7273-b4e7-99a64e3b89e2",
        "storage_key": "property/6767906449166552/019d7915-c5a1-7273-b4e7-99a64e3b89e2.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://midamericangrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5525395011336879775&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mid-american-grille",
      "poi_latitude": "36.2521318",
      "poi_longitude": "-95.3342678",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-824-7625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96_F2fo5tocRnz5z7nwlrkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_07e0f339-ff55-4d05-b679-1926e4406b00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "El Royal Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2330 NE 1st St, Pryor, OK 74361, USA",
      "poi_short_description": "Casual restaurant and bar offering tacos, fajitas, enchiladas, and other Mexican classics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-c997-70bd-87a3-9d21a1a2334e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c997-70bd-87a3-9d21a1a2334e",
        "storage_key": "property/6767906449166552/019d7915-c997-70bd-87a3-9d21a1a2334e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/pages/el-royal-restaurant/122904394426741",
      "poi_directions_map_url": "https://maps.google.com/?cid=13072953230059555386&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-royal-restaurant",
      "poi_latitude": "36.3069353",
      "poi_longitude": "-95.281138",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-825-1531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3Alvxo6tocROsr-ArN1bLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_bc718ebd-00a2-49f5-b4cf-524bcdbe678c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Goldie's Patio Grill",
      "poi_type": "Restaurants",
      "poi_address": "21 SE 8th St, Pryor, OK 74361, USA",
      "poi_short_description": "Unassuming eatery serving burgers, fried chicken & other American comfort food.",
      "poi_long_description": "People say this asador serves great burgers, fried pickles, and fried mushrooms. They also highlight the friendly staff and reasonable prices.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-ce5b-7544-813c-d91bab04379e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ce5b-7544-813c-d91bab04379e",
        "storage_key": "property/6767906449166552/019d7915-ce5b-7544-813c-d91bab04379e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.goldies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17695464834797865748&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "goldie-s-patio-grill",
      "poi_latitude": "36.2945674",
      "poi_longitude": "-95.3230744",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-825-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6T3A5M5tocRFAuLPYPrkvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_62f21dfe-1d07-4e7d-8b4b-26d9d7a0c203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Bill & Ruth's Subs and Burgers",
      "poi_type": "Restaurants",
      "poi_address": "310 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "Casual eatery serving a wide-ranging menu that includes sandwiches, spaghetti dishes, and salads for breakfast, lunch, and dinner.",
      "poi_long_description": "People say this fast food restaurant serves up delicious subs, salads, and wraps, with many raving about the Super Sub and fresh tabouli. They also highlight the friendly staff and clean atmosphere, making it a great place to enjoy a quick and tasty meal.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-d0e6-74ad-87f5-7a834087c24f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d0e6-74ad-87f5-7a834087c24f",
        "storage_key": "property/6767906449166552/019d7915-d0e6-74ad-87f5-7a834087c24f.webp",
        "width": 1280,
        "height": 438
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9956613554836585372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bill-ruth-s-subs-and-burgers",
      "poi_latitude": "36.3018195",
      "poi_longitude": "-95.3211608",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-825-1009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058e-719c-adb1-586e2a8bb76c",
        "storage_key": "property/6767906449166552/019cfb50-058e-719c-adb1-586e2a8bb76c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ_yL__E5tocRnLvflUb_LIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_194e0aff-da74-45b9-8e16-acd638d1c83d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "The District",
      "poi_type": "Shopping & Retail",
      "poi_address": "3822 W 530, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-d943-74ef-8e88-0c6bcdaec0e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d943-74ef-8e88-0c6bcdaec0e5",
        "storage_key": "property/6767906449166552/019d7915-d943-74ef-8e88-0c6bcdaec0e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lifeatthedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7649314397767121730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-district",
      "poi_latitude": "36.2501493",
      "poi_longitude": "-95.3247187",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-749-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058d-770b-b98e-d9f051b43f3b",
        "storage_key": "property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSy3He885tocRQrswvurSJ2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6969c0d7-7eb5-4539-a65e-30188b5e30ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "P&K Equipment",
      "poi_type": "Shopping & Retail",
      "poi_address": "4385 W 520 Rd, Pryor, OK 74361, USA",
      "poi_short_description": "Long-running dealer of tractors, mowers, and other farm and construction equipment, plus parts and repairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-de82-76f8-95ee-9db9bb13903d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-de82-76f8-95ee-9db9bb13903d",
        "storage_key": "property/6767906449166552/019d7915-de82-76f8-95ee-9db9bb13903d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pkequipment.com/?utm_source=google&utm_medium=organic&utm_campaign=Netsync",
      "poi_directions_map_url": "https://maps.google.com/?cid=13773357202074368176&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "p-k-equipment",
      "poi_latitude": "36.2629585",
      "poi_longitude": "-95.3351285",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-824-8541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058d-770b-b98e-d9f051b43f3b",
        "storage_key": "property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYcZ79g05tocRsPg1ombLJL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_dealer"
    },
    {
      "id": "custom_e1ea61b8-b650-4769-99cb-479b03745c56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "591 S Mill St, Pryor, OK 74361, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-dedb-72f9-a564-f1abc7dfa380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-dedb-72f9-a564-f1abc7dfa380",
        "storage_key": "property/6767906449166552/019d7915-dedb-72f9-a564-f1abc7dfa380.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-591+s+mill+st-pryor-ok-74361/id=15763",
      "poi_directions_map_url": "https://maps.google.com/?cid=16098110338576701736&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.2966918",
      "poi_longitude": "-95.3221676",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-825-5303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cayM-05tocRKFnovQ_6Z98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_29562730-eed9-4e58-a7d6-a390c3e48844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "The Village Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "219 E Graham Ave, Pryor, OK 74361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-df77-77de-8cc7-39f2be8f495b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-df77-77de-8cc7-39f2be8f495b",
        "storage_key": "property/6767906449166552/019d7915-df77-77de-8cc7-39f2be8f495b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thevillageshop.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15585310943916082613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-village-shop",
      "poi_latitude": "36.3077851",
      "poi_longitude": "-95.3164357",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-825-1661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058d-770b-b98e-d9f051b43f3b",
        "storage_key": "property/6767906449166552/019cfb50-058d-770b-b98e-d9f051b43f3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpwGGCvo5tocRtUUgnrolStg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_9204dfef-677c-48e3-92c5-e7d0c2755338",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Sequoyah State Park",
      "poi_type": "Entertainment",
      "poi_address": "17131 Park 10, Hulbert, OK 74441, USA",
      "poi_short_description": "Boating, golfing, horeseback riding & more at an expansive lake & forested area.",
      "poi_long_description": "People say this state park offers beautiful lake views, camping, fishing, hiking, and a nature center. They highlight the peaceful and clean atmosphere, and the well-maintained facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-ed3e-705c-b80d-7c115ab5e606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ed3e-705c-b80d-7c115ab5e606",
        "storage_key": "property/6767906449166552/019d7915-ed3e-705c-b80d-7c115ab5e606.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.travelok.com/listings/view.profile/id.13299",
      "poi_directions_map_url": "https://maps.google.com/?cid=1576183721353901562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sequoyah-state-park",
      "poi_latitude": "35.91637910000001",
      "poi_longitude": "-95.2501602",
      "poi_miles_from_property": "37.7 mi",
      "poi_walking_minutes": "13 hours 42 mins",
      "poi_biking_minutes": "2 hours 58 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 918-772-2545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-087e-75c9-8380-7ca9e142a665",
        "storage_key": "property/6767906449166552/019cfb50-087e-75c9-8380-7ca9e142a665.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkb_Kaj4PtocR-nUNXL663xU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_2a13d7a4-9543-4c88-971e-022f8a5161d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Thousands of aquatic species, plus a walk-through tunnel & chances to touch sharks & stingrays.",
      "poi_long_description": "People say this aquarium offers a wide variety of aquatic creatures, including sharks, sea turtles, and jellyfish, as well as some land animals. They highlight the interactive experiences, such as touch tanks and feeding opportunities, and the well-maintained exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-f094-7267-80ea-9041c76882c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f094-7267-80ea-9041c76882c7",
        "storage_key": "property/6767906449166552/019d7915-f094-7267-80ea-9041c76882c7.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "49.2 mi",
      "poi_walking_minutes": "18 hours 1 min",
      "poi_biking_minutes": "4 hours 49 mins",
      "poi_driving_minutes": "54 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_b6597765-cd66-4725-805f-18678e9ca7a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Tulsa Air and Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "3624 N 74th E Ave, Tulsa, OK 74115, USA",
      "poi_short_description": "Detailed history from 1897 to the space age plus interactive exhibits, vintage aircraft & a theater.",
      "poi_long_description": "People say this museum offers a variety of aircraft, interactive exhibits, and a planetarium. They also highlight the friendly and helpful staff, and the affordable admission.\n\nOther reviews mention some exhibits can be under repair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-f246-702b-8418-a66fc3010dd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f246-702b-8418-a66fc3010dd2",
        "storage_key": "property/6767906449166552/019d7915-f246-702b-8418-a66fc3010dd2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tulsamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16931592180727714246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-air-and-space-museum",
      "poi_latitude": "36.2067509",
      "poi_longitude": "-95.8957281",
      "poi_miles_from_property": "37.5 mi",
      "poi_walking_minutes": "13 hours 35 mins",
      "poi_biking_minutes": "3 hours 8 mins",
      "poi_driving_minutes": "43 mins",
      "poi_business_phone": "+1 918-834-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-057a-71d4-815d-39611115e1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-057a-71d4-815d-39611115e1f6",
        "storage_key": "property/6767906449166552/019cfb50-057a-71d4-815d-39611115e1f6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9UUGf_xtocRxpEOhmEZ-eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_337959c0-99f4-48d9-87be-1de3c69ceac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Historic Route 66 Pryor Creek Bridge",
      "poi_type": "Entertainment",
      "poi_address": "Chelsea, OK 74016, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-f939-768b-8399-2e15ab3a8707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f939-768b-8399-2e15ab3a8707",
        "storage_key": "property/6767906449166552/019d7915-f939-768b-8399-2e15ab3a8707.webp",
        "width": 1280,
        "height": 625
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2101479523968586214&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "historic-route-66-pryor-creek-bridge",
      "poi_latitude": "36.5383487",
      "poi_longitude": "-95.4151077",
      "poi_miles_from_property": "25.9 mi",
      "poi_walking_minutes": "9 hours 22 mins",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1yi4OwC1t4cR5pHnMH70KR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_a74b84b6-1875-4f68-9ec5-d1f8a5dc20c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Tulsa Botanic Garden",
      "poi_type": "Entertainment",
      "poi_address": "3900 Tulsa Botanic Dr, Tulsa, OK 74127, USA",
      "poi_short_description": "Botanic garden with floral terraces, a lakeside promenade, lotus pool & prairie trail, plus events.",
      "poi_long_description": "People say this botanical garden offers beautiful gardens, water features, sculptures, and a variety of flora, including flowers, trees, and shrubs. They highlight the peaceful and relaxing vibe, and the family-friendly and educational experience. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019d7915-fb5d-747d-b2bf-00659cc6a042.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fb5d-747d-b2bf-00659cc6a042",
        "storage_key": "property/6767906449166552/019d7915-fb5d-747d-b2bf-00659cc6a042.webp",
        "width": 1280,
        "height": 704
      },
      "poi_business_url": "https://www.tulsabotanic.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15418899865116188645&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-botanic-garden",
      "poi_latitude": "36.2068636",
      "poi_longitude": "-96.0621357",
      "poi_miles_from_property": "47.4 mi",
      "poi_walking_minutes": "17 hours 14 mins",
      "poi_biking_minutes": "4 hours 10 mins",
      "poi_driving_minutes": "55 mins",
      "poi_business_phone": "+1 918-289-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-058b-7159-b12f-5deef0402fc4",
        "storage_key": "property/6767906449166552/019cfb50-058b-7159-b12f-5deef0402fc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZRo6nvrtocR5Z-RB7zv-tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_045aaa88-97b6-4d4f-bb13-19b54b13d199",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "poi_name": "Rustic Shophouse",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "rustic-shophouse",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4ff079c64fad9fae62ef514d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6e1a6262eba0e44f862016f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d414ca028336f5f19d953f8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3669bfb738730f67e7796c0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c582fbd87baa55c9fc7c92f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_aa9d0162ae357271861454bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_51c556fae6bda6cbfe0b6fbe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e5799c62-2c69-4362-a794-2d6f072728a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "rating": "5.0",
      "name": "Brittany Woods",
      "text": "We have lived here for almost a month! The apartments are very nice, maintenance has been prompt for even the smallest things, the grounds have been kept clean! I see them out every morning making sure trash is picked up. There isn’t any dog feces laying around! That was a problem with our old apartment! Brandy has been nothing but kind to us and greets us by name if we go into the office! Very quiet here! Also we feel very safe! It’s lit up at night so if you have to take your pet out, you don’t even need a flash light! Cameras are everywhere also!",
      "date": "2024-05-09",
      "title": ""
    },
    {
      "id": "custom_d91fb1b4-e760-4b29-993f-db1d75fd8981",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "rating": "5.0",
      "name": "Josh Woods",
      "text": "This is like the second review I’ve written in my life. I’ve lived in several apartments over the years and living here has been my best experience to date. Everywhere I’ve ever lived had limited parking, but the spot I always park in is always available, and they’re generously wide. I never worry about people dinging my car if they park next to me or my wife’s car.\nEach apartment has fiber internet so it’s reliable and fast. Brand new appliances are in every apartment and the best part is?! Dryers that dry a load in one cycle! 🎉\nThey maintain everything quickly and keep up the property. We recently had a storm blow the privacy fencing down and it was back up before we knew it. We’ve lived here 3 months and have yet to step in dog poop. 💪🏼\nOur daughter LOVES the pool and you’d think the size of the complex would be a concern, but it’s never crowded there. It’s a true community and nobody is a stranger it seems.\nThe community is nice, quiet, and I never have to worry about my wife or daughter being outside; We don’t even need cameras covering every inch of the property, but we have that too!\nThe staff is out of this world! They’re respectful, cheerful, fast, and will hold people accountable. They’re policies are reasonable and enforced if needed.\nI work a lot and figured they’d forget I existed but anytime they see me out and about they greet me by name!\nWe have no intention of moving somewhere else anytime soon. It’s been perfect.🔥\nThe EV chargers coming will be the cherry on top once they’re here!🙏",
      "date": "2024-07-08",
      "title": ""
    },
    {
      "id": "custom_b62d1284-3c14-47a8-aa30-b33bc79b67ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "rating": "5.0",
      "name": "Robin Bryant",
      "text": "West 530 is by far one of the best places we have ever lived!\nThe Management is friendly and outstanding in communication. The apartments are fairly new so maintenance issues are rare, however, when I had an issue they were on top of it in no time!\nAlthough we have only been here a couple of months we love our apartment, it’s beautiful, quiet and we feel safe!\n\nWe are grateful we found West 530 and would recommend living here to any of our friends!",
      "date": "2025-02-13",
      "title": ""
    },
    {
      "id": "custom_a8c756f2-a337-463e-aab5-82d86eaa2f68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "rating": "5.0",
      "name": "Ricki Tudor",
      "text": "I’ve lived here since last June. The maintenance team is amazing!! They respond so quickly to my requests & always do a fantastic job of fixing things. They are kind & very respectful. I recommend living here highly!",
      "date": "2025-04-02",
      "title": ""
    },
    {
      "id": "custom_cfd8b97a-3277-41c5-abcf-e30d9b77cadf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "rating": "5.0",
      "name": "Jeff Sutton",
      "text": "Very nice apartments , I like the improvements that are being made , prompt and curtious staff , peaceful community.",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_59a68bdd-bba6-4ad1-ab0f-5801080aee5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-7e77-775f-9845-f4b1268badf2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of community game room with pool table and kitchen area",
        "public_id": "019cfb50-7e77-775f-9845-f4b1268badf2",
        "storage_key": "property/6767906449166552/019cfb50-7e77-775f-9845-f4b1268badf2.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "West 530 Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6848f49baf6f144c2685061e"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b6-116f-74ba-9198-b1655786d6d9",
      "lead_source": "LANDING_PAGE",
      "name": "case-west-530-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552"
    },
    {
      "lead_collector_id": "019cf79d-4823-7278-a449-fb3f7a47ebd5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "west-530",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-pryor-ok",
      "search_query": "apartments with in-unit laundry Pryor OK",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Pryor, OK",
      "h2_subtitle": "Discover apartments with in-unit laundry in Pryor. Experience the blend of modern convenience and tasteful design at West 530.",
      "page_copy": "At West 530, we understand the importance of convenience, which is why our Pryor, OK community features apartments with in-unit laundry. Enjoy the seamless integration of daily life with thoughtfully designed one- and two-bedroom floor plans that offer this sought-after amenity, allowing you to do laundry at your leisure without leaving the comfort of your home.\n\nBeyond the convenience of in-unit laundry, explore a wealth of amenities including energy-efficient appliances, a resort-style pool, and a 24/7 fitness center. Our serene outdoor spaces and designer finishes create a living environment that truly elevates your lifestyle. Come home to West 530 and experience why we are the premier choice for those seeking modern living in Pryor, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Pryor, OK",
      "seo_description": "Find comfort at West 530 in Pryor, OK. Apartments with in-unit laundry and modern amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-mayes-county",
      "search_query": "air conditioned apartments Mayes County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Mayes County",
      "h2_subtitle": "Stay cool and comfortable in our air conditioned apartments at West 530. Experience modern living in the heart of Mayes County.",
      "page_copy": "Welcome to West 530, where every apartment in our community is equipped with air conditioning to ensure your comfort year-round, no matter the weather outside. Located in the charming setting of Mayes County, our spacious one- and two-bedroom layouts provide a welcoming retreat with modern conveniences and designer finishes.\n\nEnjoy a balanced lifestyle with access to premium amenities including a resort-style pool, energy-efficient appliances, and a fully-equipped 24/7 fitness center. Whether you're relaxing on your private patio or taking in the serene outdoor spaces, West 530 offers an unbeatable living experience in a vibrant community. Discover what makes our air conditioned apartments the perfect home for you in Mayes County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Mayes County",
      "seo_description": "West 530 offers air conditioned apartments in Mayes County, filled with modern amenities for ultimate comfort and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "apartments-with-pool-pryor-74361",
      "search_query": "apartments with pool Pryor 74361",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Pryor, 74361",
      "h2_subtitle": "Dive into leisure at our apartments with a pool in Pryor. Enjoy West 530's vibrant lifestyle in the heart of ZIP code 74361.",
      "page_copy": "Discover the perfect blend of relaxation and lifestyle at West 530, where our apartments feature a stunning resort-style pool for residents to enjoy. Located in the heart of Pryor, ZIP code 74361, this amenity invites you to unwind and rejuvenate right at home.\n\nOur community not only offers a refreshing pool but also a range of other deluxe amenities such as energy-efficient appliances, air conditioning, and a 24/7 fitness center. Choose from well-designed one- and two-bedroom floor plans that cater to modern living with designer finishes and serene outdoor spaces. Experience all that West 530 has to offer and elevate your living experience in Pryor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool Pryor 74361",
      "seo_description": "Relax by the pool at West 530 in Pryor, 74361. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-pryor-ok",
      "search_query": "dog friendly apartments in Pryor OK",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Pryor, OK",
      "h2_subtitle": "Welcome to West 530, offering dog-friendly apartments in Pryor. Experience a perfect home for you and your furry friend.",
      "page_copy": "At West 530, we believe pets are family, which is why our community is proud to offer dog-friendly apartments in Pryor, OK. Our spacious one- and two-bedroom floor plans allow you and your furry companions to live comfortably with all the modern conveniences you desire.\n\nExplore our beautiful outdoor spaces perfect for walking and playing with your pet, while enjoying the wide array of amenities such as a resort-style pool and a 24/7 fitness center. Each apartment is equipped with energy-efficient appliances and air conditioning, creating a cozy and pet-friendly retreat. Discover why West 530 is the ultimate choice for pet lovers seeking a home in Pryor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Pryor, OK",
      "seo_description": "Find a pet-friendly home at West 530 in Pryor, OK. Enjoy amenities tailored for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-near-west-530",
      "search_query": "apartments with dishwasher near West 530",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher Near West 530",
      "h2_subtitle": "Explore modern living with apartments featuring dishwashers near West 530. Enjoy convenience and style in every unit.",
      "page_copy": "Step into a life of convenience and style at West 530, where our apartments come equipped with dishwashers, adding ease to your daily routine. Located in a prime neighborhood, these thoughtfully designed one- and two-bedroom apartments near West 530 offer everything you need for a comfortable living experience.\n\nApart from the convenience of a dishwasher, residents enjoy an array of top-notch amenities such as a refreshing resort-style pool, a 24/7 fitness center, and energy-efficient appliances. Make chores a breeze and more time for relaxation in Pryor's inviting community, designed to meet all your modern living needs with style and efficiency.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher Near West 530",
      "seo_description": "Find apartments with dishwashers at West 530. Enjoy modern amenities and prime location convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-pryor-ok",
      "search_query": "one bedroom apartments pryor ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Pryor, OK",
      "h2_subtitle": "Discover stylish one-bedroom apartments in Pryor, OK at West 530. Enjoy modern living with exceptional amenities.",
      "page_copy": "Welcome to West 530, where our one-bedroom apartments in Pryor, OK, redefine modern living with style and comfort. Each unit is equipped with designer finishes, energy-efficient appliances, and air conditioning, creating the ideal living space that combines functionality and elegance.\n\nResidents appreciate easy access to top-tier amenities, including a resort-style pool and a 24/7 fitness center. Our carefully curated spaces allow you to relax, entertain, or simply enjoy the scenic environment of our community. Whether you're looking for convenience or comfort, West 530 offers the best of both worlds in Pryor, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Pryor, OK",
      "seo_description": "Explore one-bedroom apartments at West 530 in Pryor, OK. Experience modern amenities and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-mayes-county",
      "search_query": "two bedroom apartments mayes county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Mayes County",
      "h2_subtitle": "Experience spacious two-bedroom apartments in Mayes County at West 530. Enjoy comfort and convenience in every room.",
      "page_copy": "At West 530, we offer exceptional two-bedroom apartments located in the serene setting of Mayes County. Our spacious floor plans provide ample room to make these residences your own, complete with designer finishes and energy-efficient amenities, ensuring a luxurious yet eco-friendly lifestyle.\n\nRelax around our resort-style pool after a workout in the 24/7 fitness center, and enjoy the convenience of in-home washers and air conditioning. Our community is thoughtfully designed to cater to your needs, providing a comfortable retreat in the heart of Mayes County. Discover the perfect blend of comfort and style in these premium two-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Mayes County",
      "seo_description": "Find spacious two-bedroom apartments at West 530 in Mayes County. Enjoy modern amenities and scenic local surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "apartments-near-rogers-state-university-pryor-ok",
      "search_query": "apartments near rogers state university pryor ok",
      "category": "School",
      "h1_title": "Apartments Near Rogers State University, Pryor OK",
      "h2_subtitle": "Find ideal apartments near Rogers State University in Pryor, OK at West 530. Enjoy modern living with convenient access.",
      "page_copy": "West 530 offers the perfect living solution for those seeking apartments near Rogers State University in Pryor, OK. Our location provides students and faculty with quick access to the university while enjoying the comforts of modern apartment living. Choose from spacious one- and two-bedroom layouts designed with contemporary finishes and energy-efficient appliances.\n\nResidents will appreciate top-notch amenities such as a resort-style pool and a fully-equipped 24/7 fitness center, making it easy to balance studies, work, and leisure. At West 530, enjoy a vibrant community in a convenient location ideal for those connected to Rogers State University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rogers State University, Pryor OK",
      "seo_description": "Explore West 530 apartments near Rogers State University in Pryor, OK. Enjoy convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "apartments-near-hillcrest-pryor-hospital",
      "search_query": "apartments near hillcrest pryor hospital",
      "category": "Hospital",
      "h1_title": "Apartments Near Hillcrest Pryor Hospital",
      "h2_subtitle": "Discover convenient living with apartments near Hillcrest Pryor Hospital at West 530. Enjoy easy access and top amenities.",
      "page_copy": "Located just a short distance from Hillcrest Pryor Hospital, West 530 offers the perfect blend of convenience and comfort for healthcare professionals and patients alike. Our modern apartments provide an array of floor plans, including spacious one- and two-bedroom options, each featuring stylish finishes and energy-efficient amenities.\n\nResidents at West 530 can enjoy a host of community features such as a resort-style pool, a 24/7 fitness center, and serene outdoor spaces, ensuring a balanced lifestyle. Our prime location not only offers quick access to the hospital but also to various local attractions and essentials, making these apartments an ideal choice for anyone seeking proximity to Hillcrest Pryor Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hillcrest Pryor Hospital",
      "seo_description": "Find modern apartments near Hillcrest Pryor Hospital at West 530 and enjoy convenience and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "apartments-near-whitaker-park-pryor",
      "search_query": "apartments near Whitaker Park Pryor",
      "category": "Park",
      "h1_title": "Apartments Near Whitaker Park, Pryor",
      "h2_subtitle": "Explore comfortable living in apartments near Whitaker Park, Pryor at West 530. Enjoy nearby recreational activities and modern amenities.",
      "page_copy": "Experience the best of Pryor by choosing West 530, where stylish apartments meet the tranquility of nearby Whitaker Park. Our community is perfectly positioned for those who value easy access to lush green spaces and recreational opportunities. Whether you're seeking a one or two-bedroom apartment, West 530 offers spacious floor plans featuring designer finishes.\n\nResidents enjoy a variety of amenities, including a resort-style pool, a state-of-the-art 24/7 fitness center, and peaceful outdoor spaces – perfect for relaxation after enjoying the activities Whitaker Park has to offer. Welcome to a lifestyle of convenience and comfort at West 530, located just steps from one of Pryor's premier parks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Whitaker Park, Pryor",
      "seo_description": "Discover modern living at West 530 near Whitaker Park, Pryor. Enjoy proximity to green spaces and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "rentals-close-to-websters-garden-ok-74361",
      "search_query": "rentals close to Websters Garden OK 74361",
      "category": "Park",
      "h1_title": "Rentals Close to Websters Garden, OK 74361",
      "h2_subtitle": "Uncover prime rentals close to Websters Garden, OK 74361 at West 530. Enjoy comfortable living and top amenities.",
      "page_copy": "Positioned in the heart of Pryor, West 530 presents exceptional rentals close to Websters Garden, OK 74361. Our community provides a unique blend of tranquility and modern comfort, perfect for anyone looking to enjoy the serenity of Websters Garden with convenient access to city life. Choose from various one- and two-bedroom apartment options, all equipped with stylish finishes and energy-saving appliances.\n\nAt West 530, residents benefit from upscale amenities such as a refreshing resort-style pool and a comprehensive 24/7 fitness center, ideal for those who appreciate an active lifestyle. The outdoor spaces and seamless connection to Websters Garden make our rentals an ideal choice for nature lovers and urban seekers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Websters Garden, OK 74361",
      "seo_description": "Find modern rentals near Websters Garden, OK 74361 at West 530. Enjoy tranquility and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166552",
      "source": "generator",
      "page_item_url": "pryor-apartments-by-guy-williams-park-mayes-county",
      "search_query": "Pryor apartments by Guy Williams Park Mayes County",
      "category": "Park",
      "h1_title": "Pryor Apartments by Guy Williams Park",
      "h2_subtitle": "Discover delightful Pryor apartments by Guy Williams Park in Mayes County at West 530. Enjoy peaceful surroundings and top-notch facilities.",
      "page_copy": "West 530 offers exceptional apartment living in Pryor, located conveniently by Guy Williams Park in the heart of Mayes County. Enjoy both natural beauty and modern comfort, as our community is perfectly nestled near this lush park, providing easy access to outdoor activities and beautiful walking trails. Choose from spacious one- and two-bedroom floor plans, each designed with contemporary tastes and energy efficiency in mind.\n\nOur residents benefit from upscale community amenities, including a resort-style pool, a fully-equipped 24/7 fitness center, and peaceful outdoor spaces, making West 530 the ideal home for those seeking proximity to Guy Williams Park. Embrace a lifestyle that blends leisure and modern living in our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
      "featured_image_media": {
        "alt_text": "Modern community lounge with leather seating, fireplace, and ping pong table.",
        "public_id": "019cfb4f-c8e4-7497-8ba7-6906cf5b9588",
        "storage_key": "property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pryor Apartments by Guy Williams Park",
      "seo_description": "Find stylish Pryor apartments by Guy Williams Park in Mayes County at West 530. Experience nature and modernity combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5599"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-ED82VDWW90"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128853729"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/west-530/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5HKZ3G4W"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449166552/019daca3-c344-70aa-9fc2-f1200a426ad0.webp"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40833884270"
    },
    {
      "ID": "custom_tracking_pixel_url",
      "type": "STRING",
      "value": "https://jelly.mdhv.io/v1/star.gif?pid=6V02Tl0bQmSQCXJsVBE86nUodv0X&src=mh&evt=hi"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-265-2174"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6a31e4b3ccaebd17791cc48a"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkRackwvNFJVaUFmc0QxSis4YXVmUWc9PSIsInZhbHVlIjoiREdWZHdFKzVadlFnbTFNYWg1YnhoZz09IiwibWFjIjoiOWYxN2U4Mjk2MzI2MmViYzhjZDIxMDNjZmU5ZTdhMzc3NmQ5M2ZiZDkzMmVmZTk2YjZmMjVlN2Y4NTE4OWNhNyJ9"
    }
  ],
  "custom_qb_id": "5599",
  "custom_ga4_id": "G-ED82VDWW90",
  "custom_repli_id": "18128853729",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/west-530/register/",
  "custom_google_gtm_id": "GTM-5HKZ3G4W",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449166552/019daca3-c344-70aa-9fc2-f1200a426ad0.webp",
  "custom_hubspot_company_id": "40833884270",
  "custom_tracking_pixel_url": "https://jelly.mdhv.io/v1/star.gif?pid=6V02Tl0bQmSQCXJsVBE86nUodv0X&src=mh&evt=hi",
  "custom_ppc_tracking_phone_number": "888-265-2174",
  "custom_residentboost_apartment_id": "6a31e4b3ccaebd17791cc48a",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkRackwvNFJVaUFmc0QxSis4YXVmUWc9PSIsInZhbHVlIjoiREdWZHdFKzVadlFnbTFNYWg1YnhoZz09IiwibWFjIjoiOWYxN2U4Mjk2MzI2MmViYzhjZDIxMDNjZmU5ZTdhMzc3NmQ5M2ZiZDkzMmVmZTk2YjZmMjVlN2Y4NTE4OWNhNyJ9"
};

export const generatedAt = '2026-08-27T21:33:38.543Z';
